import { CommonSetting } from './../../../commons/kymw00/common-setting';
import { KYMW0D00InputModel } from '../../../commons/kymw0d/kymw0d00/vo/kymw0d00-input.model';
import { PlessViewUtilsSub } from './../../../commons/kymw00/pless-view-utils-sub.service';
import { KYMW1100Component } from './kymw1100.component';
import { KYMW1107OutputModel } from './vo/kymw1107-output.model';
import { ElementRef } from '@angular/core';


/**
 * 商品マスタ画面の値を管理するクラス
 *
 * @export KYMW1100Model
 * @class KYMW1100Model
 */
export class KYMW1100Model {

  kymw1100Component: KYMW1100Component;

  public ratechangeBox: string = <string>'';

  // pコード情報
  public pCode: string = <string>'';
  public buyerCode: string = <string>'';
  public classDivNum: string = <string>'';

  public classCode: string = <string>'';
  public largeClassCode: string = <string>'';
  public middleClassCode: string = <string>'';
  public smallClassCode: string = <string>'';
  public dataType: string = <string>'';
  public admitStatus: string = <string>'';
  public packMaterialShowFlg: boolean = null;
  public dummyGoods: boolean = null;
  public appkyTermStart: string = <string>'';
  public appkyTermEnd: string = <string>'';
  public endFlag: boolean = null;
  public guideGoodsName: string = <string>'';
  public guideStandardName: string = <string>'';
  public categoryCode: string = <string>'';



  // 基本情報タブ
  public deliveryGoodsNameKanji: string = <string>'';
  public deliveryGoodsNameKana: string = <string>'';
  public deliveryStandardNameKanji: string = <string>'';
  public deliveryStandardNameKana: string = <string>'';
  public ocrGoodsName: string = <string>'';
  public consumeTaxDivWk: string = <string>'';			// Wk取得データ保存
  public consumeTaxRateWk: string = <string>'';			// Wk取得データ保存
  public consumeTaxDivRateScreen: string = <string>'';	// 消費税率表示用
  public consumeTaxDivRate: string = <string>'';			// マスタデータ保存
  public consumeTaxDivList: string = <string>'';			// マスタデータ保存
  public cycleTerm: string = <string>'';
  public edlpDiv: string = <string>'';
  // 表示中の消費税区分
  public selectedRateChange: string = <string>'';
  public unitPriceDiv: string = <string>'';
  public unitPriceUnit: string = <string>'';
  public unitPriceCoefficient: string = <string>'0.00';
  public guideTempZoneDiv: string = <string>'';
  public consumeTerm: string = <string>'';
  public consumeByDate: string = <string>'';
  public leaveConsumeTerm: string = <string>'';
  public seasonConsumeDiv: boolean = null;
  public seasonConsumeTerm: string = <string>'';
  public seasonConsumeTermFrom: string = <string>'';
  public seasonConsumeTermTo: string = <string>'';
  public relationPcodeOld: string = <string>'';
  public relationPcodeNew: string = <string>'';
  public blindDiv: boolean = null;
  public eFriendsSendDiv: boolean = null;
  public ecNonDispDiv: boolean = null;
  public liquorCode: string = <string>'';
  public alocoholType: string = <string>'';
  public containerForm: string = <string>'';
  public containerCapacity: string = <string>'';
  public mediumText: string = <string>'';
  public mediumList: Array<any> = new Array<any>();

    // マーク情報
  public markList: Array<any> = new Array<any>();
  public markListTmp: Array<any> = new Array<any>();
  // 選択マーク一覧
  public selectedMark: Array<any> = new Array<any>();

  // 付加情報リスト
  public textInfo1: string = <string>'';
  public textInfo2: string = <string>'';
  public textInfo3: string = <string>'';
  public textInfo4: string = <string>'';
  public textInfo5: string = <string>'';
  public textInfo6: string = <string>'';
  public textInfo7: string = <string>'';
  public textInfo8: string = <string>'';
  public textInfo9: string = <string>'';
  public textInfo10: string = <string>'';
  public textInfo11: string = <string>'';
  public textInfo12: string = <string>'';
  public textInfo13: string = <string>'';
  public textInfo14: string = <string>'';
  public textInfo15: string = <string>'';
  public textInfo16: string = <string>'';
  public textInfo17: string = <string>'';
  public textInfo18: string = <string>'';
  public textInfo19: string = <string>'';
  public textInfoCnt1: string = <string>'0件';
  public textInfoCnt2: string = <string>'0件';
  public textInfoCnt3: string = <string>'0件';
  public textInfoCnt8: string = <string>'0件';
  public textInfoCnt9: string = <string>'0件';

  public textKindDiv1: string = <string>'';
  public textKindDiv2: string = <string>'';
  public textKindDiv3: string = <string>'';
  public textKindDiv4: string = <string>'';
  public textKindDiv5: string = <string>'';
  public textKindDiv6: string = <string>'';
  public textKindDiv7: string = <string>'';
  public textKindDiv8: string = <string>'';
  public textKindDiv9: string = <string>'';
  public textKindDiv10: string = <string>'';
  public textKindDiv11: string = <string>'';
  public textKindDiv12: string = <string>'';
  public textKindDiv13: string = <string>'';
  public textKindDiv14: string = <string>'';
  public textKindDiv15: string = <string>'';
  public textKindDiv16: string = <string>'';
  public textKindDiv17: string = <string>'';
  public textKindDiv18: string = <string>'';
  public textKindDiv19: string = <string>'';

  // 発注情報タブ
  public stinkGoodsDivList: string = <string>'';
  public setDivList: string = <string>'';
  public caseSupplyDivList: string = <string>'';
  public longKeepDivList: string = <string>'';
  public assortTempdivList: string = <string>'';
  public arrivalAreaDivList: string = <string>'';
  public arrivalGoodsTemp: string = <string>'';
  public arrivalAdminDays: string = <string>'';
  public dutiesFormDailyDivList: string = <string>'';
  public fragileFlgList: string = <string>'';

  // 表組情報リスト
  public listingGoodsName: string = <string>'';

  public listingList: Array<any> = new Array<any>();
  public listingListTmp: Array<any> = new Array<any>();

  // 商品DNA情報
  public dnaList: Array<any> = new Array<any>();
  public dnaListTmp: Array<any> = new Array<any>();

  // 保健機能情報
  public licencedNo: string = <string>'';
  public textKindLicencedNo: string = <string>'';

  public licencedDescription: string = <string>'';
  public textKindLicencedDescription: string = <string>'';
  public licencedDescriptionCnt: string = <string>'0件';

  // タグ情報
  public tagInfo: Array<any> = new Array<any>();

  // 関連ページ情報
  public coopGoodsTitle: string = <string>'';
  public coopGoodsUrl: string = <string>'';
  public pageTitle: string = <string>'';
  public pageUrl: string = <string>'';

  // Item基本情報
  public itemList: Array<any> = new Array<any>();

  public itemCode: string = <string>'';

  public janCode: string = <string>'';
  public janCodeDiv: boolean = <boolean>false;

  // アイテムタブ情報
  public brandTypeList: string = <string>'';
  public fcmcFee: string = <string>'';
  public specialOrderTypeList: string = <string>'';
  public stockTypeList: string = <string>'';
  public installmentTimes: string = <string>'';
  public pdPilingUpDays: string = <string>'';
  public itfCode: string = <string>'';
  public orderUnitType: string = <string>'';
  public priceType: string = <string>'';
  public makerPrice: string = <string>'';
  public orderClientCode: string = <string>'';
  public orderClientName: string = <string>'';
  public payeeClientCode: string = <string>'';
  public payeeClientName: string = <string>'';
  public fixContainNum: string = <string>'';
  public setQuantity: string = <string>'';

  // 利用生協タブ情報
  public supplyPriceCoefficient: string = <string>'';
  public supplyPriceSpecial1: string = <string>'';
  public supplyPriceSpecial2: string = <string>'';
  public costPricecoefficient: string = <string>'';
  public costPriceSpecial1: string = <string>'';
  public costPriceSpecial2: string = <string>'';
  public bundlePrice: string = <string>'';
  public allCoop: boolean = <boolean>false;
  public zeikomi: boolean = <boolean>false;
  public allCoopIsDisable: boolean = <boolean>false;

  public texi_costPriceSpecial1: string = <string>'';
  public texi_costPriceSpecial2: string = <string>'';

  public costPriceStandard: string = <string>'';
  public consumeMessage: string = <string>'';

  public coopInfoWkList: Array<any> = new Array<any>();
  public coopInfoWkListTmp: Array<any> = new Array<any>();

  public coopInfoListScreen: Array<any> = new Array<any>();
  public coopInfoList: Array<any> = new Array<any>();
  public coopInfoListTmp: Array<any> = new Array<any>();

  // 仕様書１タブ情報
  public ebaseSpecCode: string = <string>'';
  public specApplyDate: string = <string>'';
  public ebaseGetDate: string = <string>'';
  public registCatalogRound: string = <string>'';
  public makerName: string = <string>'';
  public makerNamePublishType: boolean = null;
  public peaceSizeLength: string = <string>'';
  public peaceSizeWidth: string = <string>'';
  public peaceSizeHight: string = <string>'';
  public peaceSizeWeight: string = <string>'';
  public caseSizeLength: string = <string>'';
  public caseSizeWidth: string = <string>'';
  public caseSizeHight: string = <string>'';
  public caseSizeWeight: string = <string>'';

  // テキスト
  public stringValue1: string = <string>'';
  public stringValue2: string = <string>'';
  public stringValue3: string = <string>'';
  public stringValue4: string = <string>'';
  public stringValue5: string = <string>'';
  public geneRecombinationDiv: string = <string>'';
  public stringValue6: string = <string>'';

  public textInfoDiv1: string = <string>'';
  public textInfoDiv2: string = <string>'';
  public textInfoDiv3: string = <string>'';
  public textInfoDiv4: string = <string>'';
  public textInfoDiv5: string = <string>'';
  public textInfoDiv6: string = <string>'';
  public ebaseSpecCodeRev: string = <string>''; // ｅＢＡＳＥ仕様書コード（改訂）

  // 仕様書2タブ情報
  public allergenTargetType: string = <string>'';
  public allergenList: Array<any> = new Array<any>();
  public allergenListTmp: Array<any> = new Array<any>();

  public analysisUnit: string = <string>'';
  public calorie: string = <string>'';
  public protein: string = <string>'';
  public lipid: string = <string>'';
  public carbohydrate: string = <string>'';
  public sodium: string = <string>'';

  public updateDate: string = <string>'';
  public registDate: string = <string>'';
  // 誌面栄養成分情報
  // 表示用・分析単位リスト
  // 分析単位：String
  public nutrientUnitList: Array<any> = new Array<any>();
  // 栄養成分詳細リスト
  // 栄養成分詳細：any
  // 栄養成分名：String
  // 栄養成分量：String
  // 栄養成分単位：String
  public nutrientDetailList: Array<any> = new Array<any>();
  public nutritionalNote: string = <string>'';
  public hasMultiNutrientInfo: boolean = null;
  // 複数栄養成分情報
  // 表示用・分析単位リスト
  // 分析単位：String
  public nutrientUnitListMulti: Array<any> = new Array<any>();
  // 栄養成分詳細リスト
  // 栄養成分詳細：any
  // 栄養成分名：String
  // 栄養成分量：String
  // 栄養成分単位：String
  // 表示区分：String
  // 階層：String
  public nutrientDetailListMulti: Array<any> = new Array<any>();
  public nutritionalNoteMulti: string = <string>'';
  // 栄養成分情報 hidden
  // 栄養成分情報リスト：Array<any>
  // 栄養成分情報：any
  // 分析連番：String
  // 分析単位：String
  // 栄養成分備考：String
  // 栄養成分詳細リスト：Array<any>
  // 栄養成分詳細：any
  // 栄養成分名：String
  // 栄養成分量：String
  // 栄養成分単位：String
  // 表示区分：String
  // 階層：String
  public hiddenNutrientComponentList: Array<any> = new Array<any>();

  // 環境関連タブ情報
  public ecology: string = <string>'';
  public goodsEcologyList: Array<any> = new Array<any>();
  public goodsEcologyListTmp: Array<any> = new Array<any>();

  public goodsGWStopList: Array<any> = new Array<any>();
  public goodsGWStopListTmp: Array<any> = new Array<any>();

  public containPackingList: Array<any> = new Array<any>();
  public containPackingListTmp: Array<any> = new Array<any>();

  public tradeStopDivOrder: string = <string>'';
  public tradeStopDivPayee: string = <string>'';

  public initPhase: boolean = <boolean>false;

  // 商品仕様書マスタ情報
  public pieceSizeLength: string = <string>'';		// ピースサイズ(縦)
  public pieceSizeWidth: string = <string>'';		// ピースサイズ(横)
  public pieceSizeHeight: string = <string>'';		// ピースサイズ(高)
  public pieceWeight: string = <string>'';			// ピース重量
  public pieceContainNum: string = <string>'';		// ピース入数
  public pieceJanCode: string = <string>'';			// ピースＪＡＮコード
  public packSizeLength: string = <string>'';		// パックサイズ(縦)
  public packSizeWidth: string = <string>'';			// パックサイズ(横)
  public packSizeHeight: string = <string>'';			// パックサイズ(高)
  public packWeight: string = <string>'';			// パック重量
  public packContainNum: string = <string>'';		// パック入数
  public packJanCode: string = <string>'';			// パックＪＡＮコード
  public bowlSizeLength: string = <string>'';		// ボールサイズ(縦)
  public bowlSizeWidth: string = <string>'';			// ボールサイズ(横)
  public bowlSizeHeight: string = <string>'';			// ボールサイズ(高)
  public bowlWeight: string = <string>'';			// ボール重量
  public bowlContainNum: string = <string>'';		// ボール入数
  public bowlJanCode: string = <string>'';			// ボールＪＡＮコード
  public caseSizeLengthEbase: string = <string>'';	// ケースサイズ(縦)
  public caseSizeWidthEbase: string = <string>'';	// ケースサイズ(横)
  public caseSizeHeightEbase: string = <string>'';	// ケースサイズ(高)
  public caseWeightEbase: string = <string>'';		// ケース重量
  public caseContainNumEbase: string = <string>'';	// ケース入数
  public caseJanCodeEbase: string = <string>'';		// ケースＪＡＮコード
  public factoryAddress: string = <string>'';		// 工場住所
  public fragileFlg: string = <string>'';			// 割れ物フラグ

  // その他設定項目情報

  // 仕様反映フラグ true:仕様反映直後 false:仕様反映直後以外
  public ebaseDataReflectionFlag: boolean = null;

  // eBASE仕様書コード重複チェック結果格納領域
  public copyEbaseSpecCodeCheckRsult: string = <string>'';

  // ファイル選択ダイアログにて選択した、アップロードファイル情報格納領域
  public tmpFileRef: File;

  public def_ConsumeTaxRate: string = <string>'';					// 消費税率(増税まえ)
  public def_ConsumeTaxRate_2: string = <string>'';					// 消費税率(増税あと)

  // 活性非活性フラグ
  public enabledInfo1Flg: boolean = <boolean>false;      // 左側の活性フラグ
  public enabledInfo2Flg: boolean = <boolean>false;      // 右側の活性フラグ

  // メニュー活性非活性
  public enabledGoodsPcodeFlg: boolean = <boolean>true;
  public enabledGoodsCopyFlg: boolean = <boolean>false;
  public enabledGoodsSpecFlg: boolean = <boolean>true;
  public enabledEBaseImportFlg: boolean = <boolean>true;
  public enabledGoodsDeleteFlg: boolean = <boolean>false;
  public enabledGoodsKYMW1104Flg: boolean = <boolean>false;
  public enabledFoodsFlg: boolean = <boolean>true;
  public enabledHouseholdFlg: boolean = <boolean>true;
  public enabledCosmeticsFlg: boolean = <boolean>true;

  // コンテキストメニュー活性非活性
  // 栄養成分 分析単位
  public enabledNutrientUnitAddFlg: boolean = <boolean>false;
  public enabledNutrientUnitUpdateFlg: boolean = <boolean>false;
  public enabledNutrientUnitRemoveFlg: boolean = <boolean>false;
  // 複数栄養成分 分析単位
  public enabledNutrientUnitMultiAddFlg: boolean = <boolean>false;
  public enabledNutrientUnitMultiUpdateFlg: boolean = <boolean>false;
  public enabledNutrientUnitMultiRemoveFlg: boolean = <boolean>false;

  // 背景色
  public color: string = <string>'';

  // 候補リストタブ
  // 検索条件
  public searchPcode = String('');						        	    // Pコード
  public searchItemCode = String('');						            // アイテムコード
  public searchJanCode = String('');						          	// JANコード
  public searchMakerName = String('');						          // メーカ名
  public searchGuideGoodsName = String('');				          // 商品案内用商品名
  public searchGuideStandardName = String('');		          // 商品案内用規格名
  public searchTagSearchType = String('');	        	    	// タグ検索方法
  public searchGoodsMarkSearchType = String('');						// 商品マーク検索方法
  public searchDataKbnFlg = Boolean(false);	                // 取扱終了商品を含む
  public searchGoodsDiv = String('');	                      // ダミー商品
  public searchBuyerCode = String('');						          // バイヤーコード
  public searchAdmitStatus = String('');					        	// 登録レベル
  public searchRegistDateFrom = String('');			        		// 商品マスタ登録日From
  public searchRegistDateTo = String('');				        	  // 商品マスタ登録日To
  public searchUpdateDateFrom = String('');			        		// 商品マスタ更新日From
  public searchUpdateDateTo = String('');					          // 商品マスタ更新日To
  public searchClassCode = String('');					        	  // 部門コード
  public searchMiddleClassCode = String('');		        		// 中分類コード
  public searchSmallClassCode = String('');			        		// 小分類コード
  public searchOrdrClientCode = String('');					        // 発注先コード
  public searchOrdrClientKanji = String('');				        // 発注先名称
  public searchPayeeClientCode = String('');				        // 支払先コード
  public searchPayeeClientKanji = String('');			        	// 支払先名称
  public searchDuties = String('');                         // 業態区分
  public searchPcodeList = Array<string>();						      // Ｐコードリスト
  public searchItemCodeList = Array<string>();						  // アイテムコードリスト
  public searchTagIdList = Array<string>();                 // タグリスト
  public searchGoodsMarkCodeList = Array<string>();         // 商品マークコードリスト
  public searchCoopCodeList = Array<string>();              // 生協コードリスト
  public sortKey = String('');							                // ソートキー
  public orderKey = String('');						                  // 降順または昇順

  // ボタンの活性非活性制御用
  public btnOutEnabled = Boolean(false);
  public btnBackEnabled = Boolean(false);
  public btnNextEnabled = Boolean(false);

  // 検索結果
  public candidateGoodsList: Array<any>;
  // 検索結果合計数
  public totalNum = Number(0);
  // 検索結果 件数 start
  public startDispNum = Number(0);
  // 検索結果 件数 end
  public endDispNum = Number(0);

  /** 出力時のファイルURL */
  public fileUrl = String('');
  /** ページ番号 */
  public pageNo = Number(1);

  //  候補リスト出力最大件数
  public goodsFileMaxCount: string = CommonSetting.getVal('GoodsFileMaxCount');

  /**
   * pCode情報取得(初期表示)
   * @param serverData ユーザーリストのサーバ取得データ
   */
  public updateGoodsBaseData(serverData: any): void {
    // Pコート基本情報
    this.pCode = serverData.GoodsBaseData.PCode;
    this.buyerCode = serverData.GoodsBaseData.BuyerCode;
    this.kymw1100Component.cmb_BuyerCode.setCodeValue(serverData.GoodsBaseData.BuyerCode);


    this.admitStatus = serverData.GoodsBaseData.AdmitStatus;

    if (this.admitStatus === '0') {
      this.kymw1100Component.rdb_AdmitStatus0.disabled = false;
      this.kymw1100Component.rdb_AdmitStatus1.disabled = false;
      this.kymw1100Component.rdb_AdmitStatus2.disabled = true;
      this.kymw1100Component.chk_PackMaterialShowFlg.nativeElement.disabled = true;
    } else if (this.admitStatus === '1') {
      this.kymw1100Component.rdb_AdmitStatus0.disabled = true;
      this.kymw1100Component.rdb_AdmitStatus1.disabled = false;
      this.kymw1100Component.rdb_AdmitStatus2.disabled = true;
      this.kymw1100Component.chk_PackMaterialShowFlg.nativeElement.disabled = false;
    } else if (this.admitStatus === '2') {
      this.kymw1100Component.rdb_AdmitStatus0.disabled = true;
      this.kymw1100Component.rdb_AdmitStatus1.disabled = true;
      this.kymw1100Component.rdb_AdmitStatus2.disabled = false;
      this.kymw1100Component.chk_PackMaterialShowFlg.nativeElement.disabled = true;
    }

    if (serverData.GoodsBaseData.PackMaterialShowFlg === '1') {
      this.packMaterialShowFlg = true;
      this.kymw1100Component.rdb_AdmitStatus2.disabled = false;
    } else if (serverData.GoodsBaseData.PackMaterialShowFlg === '0') {
      this.packMaterialShowFlg = false;
    }

    if (serverData.GoodsBaseData.GoodsDiv === '1') {
      this.dummyGoods = true;
    } else {
      this.dummyGoods = false;
    }

    this.classDivNum = serverData.GoodsBaseData.ClassDivNum;

    this.kymw1100Component.cmb_ClassCode.setClassCode(serverData.GoodsBaseData.ClassCode);
    setTimeout(() => {
      this.kymw1100Component.cmb_LargeClassCode.setLargeClassCode(serverData.GoodsBaseData.LargeClassCode);
    }, 100);
    setTimeout(() => {
      this.kymw1100Component.cmb_MiddleClassCode.setMiddleClassCode(serverData.GoodsBaseData.MiddleClassCode);
    }, 200);
    setTimeout(() => {
      this.kymw1100Component.cmb_SmallClassCodeList.setSmallClassCode(serverData.GoodsBaseData.SmallClassCode);
    }, 300);

    this.dataType = serverData.GoodsBaseData.DataType;

    if (serverData.GoodsBaseData.ApplyTermStart != null) {
      // /区切り
      this.appkyTermStart = PlessViewUtilsSub.editDate(serverData.GoodsBaseData.ApplyTermStart, '2');
    } else {
      this.appkyTermStart = null;
    }

    if (!PlessViewUtilsSub.isEmpty(serverData.GoodsBaseData.ApplyTermEnd)
    && serverData.GoodsBaseData.ApplyTermEnd !== '99999999') {
      this.endFlag = false;
      this.kymw1100Component.dtf_AppkyTermEnd.isDisabled = false;
      // 日付入力を非活性にする(カレンダーのみ有効)
      this.appkyTermEnd = PlessViewUtilsSub.editDate(serverData.GoodsBaseData.ApplyTermEnd, '2');
    } else {
      this.endFlag = true;
      this.kymw1100Component.dtf_AppkyTermEnd.isDisabled = true;
      this.appkyTermEnd = null;
    }

    this.guideGoodsName = serverData.GoodsBaseData.GuideGoodsName;
    this.guideStandardName = serverData.GoodsBaseData.GuideStandardName;

    this.categoryCode = serverData.GoodsBaseData.CategoryCode;

    // 基本情報タブ
    this.deliveryGoodsNameKanji = serverData.GoodsBaseData.DeliveryGoodsNameKanji;
    this.deliveryGoodsNameKana = serverData.GoodsBaseData.DeliveryGoodsNameKana;
    this.deliveryStandardNameKanji = serverData.GoodsBaseData.DeliveryStandardNameKanji;
    this.deliveryStandardNameKana = serverData.GoodsBaseData.DeliveryStandardNameKana;
    this.ocrGoodsName = serverData.GoodsBaseData.OcrGoodsName;
    this.consumeTaxDivWk = PlessViewUtilsSub.nullToBlank(serverData.GoodsBaseData.ConsumeTaxDivWk);
    this.consumeTaxRateWk = PlessViewUtilsSub.nullToBlank(serverData.GoodsBaseData.ConsumeTaxRateWk);

    this.consumeTaxDivList = PlessViewUtilsSub.nullToBlank(serverData.GoodsBaseData.ConsumeTaxDiv);
    this.consumeTaxDivRate = PlessViewUtilsSub.nullToBlank(serverData.GoodsBaseData.ConsumeTaxRate);

    // 表示更新
    this.kymw1100Component.setConsumeDivAndTax(this.consumeTaxDivList, this.consumeTaxDivRate);

    this.cycleTerm = serverData.GoodsBaseData.CycleTerm;
    this.kymw1100Component.cmb_CycleTerm.setCodeValue(serverData.GoodsBaseData.CycleTerm);

    this.edlpDiv = serverData.GoodsBaseData.EdlpDiv;
    this.kymw1100Component.cmb_EdlpDiv.setCodeValue(serverData.GoodsBaseData.EdlpDiv);
    this.guideTempZoneDiv = serverData.GoodsBaseData.GuideTempZoneDiv;
    this.kymw1100Component.cmb_GuideTempZoneDiv.setCodeValue(serverData.GoodsBaseData.GuideTempZoneDiv);
    this.kymw1100Component.cmb_UnitPriceDiv.setCodeValue(serverData.GoodsBaseData.UnitPriceDiv);

    this.unitPriceCoefficient = serverData.GoodsBaseData.UnitPriceCoefficient === '0' ?
      '0.00' : serverData.GoodsBaseData.UnitPriceCoefficient;
    this.unitPriceUnit = serverData.GoodsBaseData.UnitPriceUnit;
    this.consumeTerm = serverData.GoodsBaseData.ConsumeTerm;
    this.consumeByDate = serverData.GoodsBaseData.ConsumeByDate;
    this.leaveConsumeTerm = serverData.GoodsBaseData.LeaveConsumeTerm;
    this.blindDiv = serverData.GoodsBaseData.BlindDiv;
    this.kymw1100Component.cmb_BlindDiv.setCodeValue(serverData.GoodsBaseData.BlindDiv);
    this.ecNonDispDiv = serverData.GoodsBaseData.EcNonDispDiv;
    this.kymw1100Component.cmb_EcNonDispDiv.setCodeValue(serverData.GoodsBaseData.EcNonDispDiv);
    this.liquorCode = serverData.GoodsBaseData.LiquorCode;
    this.kymw1100Component.cmb_LiquorCode.setCodeValue(serverData.GoodsBaseData.LiquorCode);
    this.containerForm = serverData.GoodsBaseData.ContainerForm;
    this.kymw1100Component.cmb_ContainerForm.setCodeValue(serverData.GoodsBaseData.ContainerForm);

    if (serverData.GoodsBaseData.SeasonConsumeDiv === '1') {
      this.seasonConsumeDiv = true;

      // 季節消費期限開始NULLチェック
      if (serverData.GoodsBaseData.SeasonConsumeTermFrom != null) {
        this.seasonConsumeTermFrom = serverData.GoodsBaseData.SeasonConsumeTermFrom.substr(0, 2)
          + serverData.GoodsBaseData.SeasonConsumeTermFrom.substr(2, 4);
      } else {
        this.seasonConsumeTermFrom = null;
      }
      // 季節消費期限終了NULLチェック
      if (serverData.GoodsBaseData.SeasonConsumeTermTo != null) {
        this.seasonConsumeTermTo = serverData.GoodsBaseData.SeasonConsumeTermTo.substr(0, 2)
          + serverData.GoodsBaseData.SeasonConsumeTermTo.substr(2, 4);
      } else {
        this.seasonConsumeTermTo = null;
      }
      // 季節消費期限日NULLチェック
      if (serverData.GoodsBaseData.SeasonConsumeTerm != null) {
        this.seasonConsumeTerm = serverData.GoodsBaseData.SeasonConsumeTerm;
      } else {
        this.seasonConsumeTerm = '';
      }

      this.kymw1100Component.txti_SeasonConsumeTerm.nativeElement.disabled = false;
      this.kymw1100Component.dtf_SeasonConsumeTermFrom.isDisabled = false;
      this.kymw1100Component.dtf_SeasonConsumeTermTo.isDisabled = false;
    } else {
      this.seasonConsumeDiv = false;
      this.seasonConsumeTerm = '';
      this.seasonConsumeTermFrom = null;
      this.seasonConsumeTermTo = null;
      this.kymw1100Component.txti_SeasonConsumeTerm.nativeElement.disabled = true;
      this.kymw1100Component.dtf_SeasonConsumeTermFrom.isDisabled = true;
      this.kymw1100Component.dtf_SeasonConsumeTermTo.isDisabled = true;
    }

    if (serverData.GoodsBaseData.EFriendsSendDiv === '1') {
      this.eFriendsSendDiv = true;
    } else {
      this.eFriendsSendDiv = false;
    }

    if (serverData.GoodsBaseData.RelationPcodeOld != null) {
      this.relationPcodeOld = serverData.GoodsBaseData.RelationPcodeOld;
    } else {
      this.relationPcodeOld = '';
    }

    if (serverData.GoodsBaseData.RelationPcodeNew != null) {
      this.relationPcodeNew = serverData.GoodsBaseData.RelationPcodeNew;
    } else {
      this.relationPcodeNew = '';
    }
    this.alocoholType = serverData.GoodsBaseData.AlocoholType;
    this.containerCapacity = serverData.GoodsBaseData.ContainerCapacity;

    // 発注情報タブ
    this.stinkGoodsDivList = serverData.GoodsBaseData.StinkGoodsDiv;
    this.kymw1100Component.cmb_StinkGoodsDivList.setCodeValue(serverData.GoodsBaseData.StinkGoodsDiv);
    this.setDivList = serverData.GoodsBaseData.SetDiv;
    this.kymw1100Component.cmb_SetDivList.setCodeValue(serverData.GoodsBaseData.SetDiv);
    this.caseSupplyDivList = serverData.GoodsBaseData.CaseSupplyDiv;
    this.kymw1100Component.cmb_CaseSupplyDivList.setCodeValue(serverData.GoodsBaseData.CaseSupplyDiv);
    this.longKeepDivList = serverData.GoodsBaseData.LongKeepDiv;
    this.kymw1100Component.cmb_LongKeepDivList.setCodeValue(serverData.GoodsBaseData.LongKeepDiv);
    this.assortTempdivList = serverData.GoodsBaseData.AssortTempdiv;
    this.kymw1100Component.cmb_AssortTempdivList.setCodeValue(serverData.GoodsBaseData.AssortTempdiv);
    this.arrivalAreaDivList = serverData.GoodsBaseData.ArrivalAreaDiv;
    this.kymw1100Component.cmb_ArrivalAreaDivList.setCodeValue(serverData.GoodsBaseData.ArrivalAreaDiv);
    // 業態区分（デイリー）コンボボックスの初期表示
    this.dutiesFormDailyDivList = serverData.GoodsBaseData.DutiesFormDailyDiv;
    this.kymw1100Component.cmb_DutiesFormDailyDivList.setCodeValue(serverData.GoodsBaseData.DutiesFormDailyDiv);
    // 割れ物フラグ コンボボックスの初期表示
    this.fragileFlgList = serverData.GoodsBaseData.FragileFlg;
    this.kymw1100Component.cmb_FragileFlgList.setCodeValue(serverData.GoodsBaseData.FragileFlg);

    this.arrivalGoodsTemp = serverData.GoodsBaseData.ArrivalGoodsTemp;
    this.arrivalAdminDays = serverData.GoodsBaseData.ArrivalAdminDays;

    this.listingGoodsName = serverData.GoodsBaseData.ListingGoodsName;

    const consumeTaxList: Array<any> = serverData.ConsumeTaxList.ConsumeTaxInfo;
    this.def_ConsumeTaxRate = consumeTaxList[0].ConsumeTaxRate;
    this.def_ConsumeTaxRate_2 = consumeTaxList[1].ConsumeTaxRate;

    // 関連ページタブ
    this.coopGoodsTitle = serverData.GoodsBaseData.CoopGoodsTitle;
    this.coopGoodsUrl = serverData.GoodsBaseData.CoopGoodsUrl;
    this.pageTitle = serverData.GoodsBaseData.PageTitle;
    this.pageUrl = serverData.GoodsBaseData.PageUrl;
  }

  /**
   * pCode情報取得(初期表示)
   * @param serverData ユーザーリストのサーバ取得データ
   */
  public updateMarkInfoList(serverData: any): void {
    if (serverData.MarkInfoList && serverData.MarkInfoList.Mark) {
      this.markList = serverData.MarkInfoList.Mark;
      this.markListTmp = this.markList;

      const markList32: Array<any> = new Array<any>();
      for (let i = Number(0); i < this.markList.length; i++) {
        const vo = {
          Check: false,
          MarkCode: PlessViewUtilsSub.zeroPadding(3, this.markList[i].Code),
          MarkName: this.markList[i].Name,
          MarkGroupCode: this.markList[i].GroupCode,
          Caption: this.markList[i].Caption,
        };

        markList32.push(vo);
      }
      this.markList = markList32;
    } else {
      this.markList = null;
      this.markListTmp = this.markList;
    }
    this.setInitialFocus();
  }

  /**
    * pCode情報取得(検索後)
    * @param serverData ユーザーリストのサーバ取得データ
    */
  public updateMarkCodeList(serverData: any): void {
    if (serverData.MarkCodeList && serverData.MarkCodeList.List) {
      // MarkCodeのみ
      const markCodeList: Array<any> = serverData.MarkCodeList.List;
      const markList32: Array<any> = new Array<any>();
      const selectmarkList: Array<any> = new Array<any>();

      if (this.markListTmp != null) {
        for (let i = Number(0); i < this.markListTmp.length; i++) {
          const check: boolean = this.isExistMarkCode(markCodeList, this.markListTmp[i].Code);

          const vo = {
            Check: check,
            MarkCode: PlessViewUtilsSub.zeroPadding(3, this.markListTmp[i].Code),
            MarkName: this.markListTmp[i].Name,
            MarkGroupCode: this.markListTmp[i].GroupCode,
            Caption: this.markListTmp[i].Caption,
          };

          markList32.push(vo);

          if (check) {
            const selectvo = {
              MarkCode: PlessViewUtilsSub.zeroPadding(3, this.markListTmp[i].Code),
              MarkName: this.markListTmp[i].Name,
              MarkGroupCode: this.markListTmp[i].GroupCode,
              Caption: this.markListTmp[i].Caption,
            };
            selectmarkList.push(selectvo);
          }
        }
        this.markList = markList32;
        this.createSelectedMarkList(selectmarkList);
      } else {
        this.markList = null;
      }
    } else {
      const markListTmp32: Array<any> = new Array<any>();
      if (this.markListTmp != null) {
        for (let j = Number(0); j < this.markListTmp.length; j++) {
          const goodsMarkTmpXml = {
            Check: false,
            MarkCode: PlessViewUtilsSub.zeroPadding(3, this.markListTmp[j].Code),
            MarkName: this.markListTmp[j].Name,
            MarkGroupCode: this.markListTmp[j].GroupCode,
            Caption: this.markListTmp[j].Caption,
          };
          markListTmp32.push(goodsMarkTmpXml);
        }

        this.markList = markListTmp32;
      } else {
        this.markList = null;
      }
    }
  }

  /**
    * Pコードがある時にtrueを返す。
    */
  private isExistMarkCode(markCodeList: Array<any>, markCode: string): boolean {
    for (let i = Number(0); i < markCodeList.length; i++) {
      if (markCodeList[i].MarkCode === markCode) {
        return true;
      }
    }
    return false;
  }

  /**
  * pCode情報取得(CheckBoxイベント発生)
  * @param serverData ユーザーリストのサーバ取得データ
  */
  public updateSelectedMarkInfo(): void {
    const newSelectedMarkList: Array<any> = new Array<any>();
    for (let i = Number(0); i < this.markList.length; i++) {
      if (this.markList[i].Check) {
        const selectedvo = {
          MarkCode: PlessViewUtilsSub.zeroPadding(3, this.markList[i].MarkCode),
          MarkName: this.markList[i].MarkName,
          MarkGroupCode: this.markList[i].MarkGroupCode,
          Caption: this.markList[i].Caption,
        };

        newSelectedMarkList.push(selectedvo);
      }
    }
    this.createSelectedMarkList(newSelectedMarkList);
    this.kymw1100Component.dtg_SelectedMark.refreshCells(true);
  }


  /**
    * 選択マーク一覧（データグリッド）の設定を行う
    * チェック行のデータを基に表示用のフォーマットに変換する
    */
  private createSelectedMarkList(selectList: Array<any>): void {

    const tempSelectList = new Array<any>();

    if (selectList != null && !PlessViewUtilsSub.isEmptyArray(selectList)) {

      // 昇順に並び替え(マークグループ,マークコードの順)
      const tempMarkSelectList =
        selectList.sort(function (a, b) {
          if (Number(a.MarkGroupCode) > Number(b.MarkGroupCode)) {
 return 1;
}
          if (Number(a.MarkGroupCode) < Number(b.MarkGroupCode)) {
 return -1;
}
          if (Number(a.MarkCode) > Number(b.MarkCode)) {
 return 1;
}
          if (Number(a.MarkCode) < Number(b.MarkCode)) {
 return -1;
}
          return 0;
        });

      // 初期化
      let keyMarkGroup: string = <string>'';
      let dispCaption: string = <string>'';
      let dispName: string = <string>'';

      for (let i = Number(0); i <= tempMarkSelectList.length; i++) {
        // １行目の場合はキーを設定
        if (i === 0) {
          keyMarkGroup = tempMarkSelectList[i].MarkGroupCode;
        } else if (i === tempMarkSelectList.length) {
          // 配列最後の場合
          tempSelectList.push({
            Caption: dispCaption,
            MarkName: dispName,
          });
          break;
        }

        if (keyMarkGroup !== tempMarkSelectList[i].MarkGroupCode) {
          // キーが変わったとき、または配列の最終処理の場合に追加
          tempSelectList.push({
            Caption: dispCaption,
            MarkName: dispName,
          });
          // キーの上書き
          keyMarkGroup = tempMarkSelectList[i].MarkGroupCode;
          // dispNameのクリア
          dispName = '';
        } else {
          // 同一グループコードの場合は「,」区切りで内容を表示する
          if (dispName.length > 0) {
            dispName += ',';
          }
        }
        // ループ処理の終わりにデータを設定
        dispName += tempMarkSelectList[i].MarkName;
        dispCaption = tempMarkSelectList[i].Caption;
      }
    }
    this.selectedMark = tempSelectList;
  }

  /**
    * pCode情報の付加タブ取得(初期表示)
    * @param serverData ユーザーリストのサーバ取得データ
    */
  public updateTextInfoList(serverData: any): void {
    if (serverData.TextInfoList && serverData.TextInfoList.List) {
      const textInfoList = serverData.TextInfoList.List;

      for (let i = Number(0); i < textInfoList.length; i++) {
        switch (textInfoList[i].TextKindID) {
          // Pコード項目
          case '001':
            this.textKindDiv1 = textInfoList[i].TextKindID;
            this.textInfo1 = textInfoList[i].StringValue;
            break;
          case '004':
            this.textKindDiv2 = textInfoList[i].TextKindID;
            this.textInfo2 = textInfoList[i].StringValue;
            break;
          case '018':
            this.textKindDiv3 = textInfoList[i].TextKindID;
            this.textInfo3 = textInfoList[i].StringValue;
            break;
          case '019':
            this.textKindDiv4 = textInfoList[i].TextKindID;
            this.textInfo4 = textInfoList[i].StringValue;
            break;
          case '008':
            this.textKindDiv5 = textInfoList[i].TextKindID;
            this.textInfo5 = textInfoList[i].StringValue;
            break;
          case '023':
            this.textKindDiv6 = textInfoList[i].TextKindID;
            this.textInfo6 = textInfoList[i].StringValue;
            break;
          case '022':
            this.textKindDiv7 = textInfoList[i].TextKindID;
            this.textInfo7 = textInfoList[i].StringValue;
            break;
          case '024':
            this.textKindDiv8 = textInfoList[i].TextKindID;
            this.textInfo8 = textInfoList[i].StringValue;
            break;
          case '003':
            this.textKindDiv9 = textInfoList[i].TextKindID;
            this.textInfo9 = textInfoList[i].StringValue;
            break;
          case '032':
            this.textKindLicencedNo = textInfoList[i].TextKindID;
            this.licencedNo = textInfoList[i].StringValue;
            break;
          case '033':
            this.textKindLicencedDescription = textInfoList[i].TextKindID;
            this.licencedDescription = textInfoList[i].StringValue;
            break;
          case '034':
            this.textKindDiv10 = textInfoList[i].TextKindID;
            this.textInfo10 = textInfoList[i].StringValue;
            break;
          case '035':
            this.textKindDiv11 = textInfoList[i].TextKindID;
            this.textInfo11 = textInfoList[i].StringValue;
            break;
          case '036':
            this.textKindDiv12 = textInfoList[i].TextKindID;
            this.textInfo12 = textInfoList[i].StringValue;
            break;
          case '037':
            this.textKindDiv13 = textInfoList[i].TextKindID;
            this.textInfo13 = textInfoList[i].StringValue;
            break;
          case '038':
            this.textKindDiv14 = textInfoList[i].TextKindID;
            this.textInfo14 = textInfoList[i].StringValue;
            break;
          case '040':
            this.textKindDiv15 = textInfoList[i].TextKindID;
            this.textInfo15 = textInfoList[i].StringValue;
            break;
          case '041':
            this.textKindDiv16 = textInfoList[i].TextKindID;
            this.textInfo16 = textInfoList[i].StringValue;
            break;
          case '042':
            this.textKindDiv17 = textInfoList[i].TextKindID;
            this.textInfo17 = textInfoList[i].StringValue;
            break;
          case '043':
            this.textKindDiv18 = textInfoList[i].TextKindID;
            this.textInfo18 = textInfoList[i].StringValue;
            break;
          case '039':
            this.textKindDiv19 = textInfoList[i].TextKindID;
            this.textInfo19 = textInfoList[i].StringValue;
            break;
        }
      }
    }

    if (serverData.TextInfoCountList && serverData.TextInfoCountList.List) {
      const textInfoCountList = serverData.TextInfoCountList.List;

      for (let j = Number(0); j < textInfoCountList.length; j++) {
        switch (textInfoCountList[j].TextKindID) {
          case '001':
            this.textInfoCnt1 = this.editTextInfoCount(textInfoCountList[j].TextInfoCnt);
            break;
          case '004':
            this.textInfoCnt2 = this.editTextInfoCount(textInfoCountList[j].TextInfoCnt);
            break;
          case '018':
            this.textInfoCnt3 = this.editTextInfoCount(textInfoCountList[j].TextInfoCnt);
            break;
          case '024':
            this.textInfoCnt8 = this.editTextInfoCount(textInfoCountList[j].TextInfoCnt);
            break;
          case '003':
            this.textInfoCnt9 = this.editTextInfoCount(textInfoCountList[j].TextInfoCnt);
            break;
          case '033':
            this.licencedDescriptionCnt = this.editTextInfoCount(textInfoCountList[j].TextInfoCnt);
            break;
        }
      }
    }
  }

  /**
    * pCode情報の表組タブ取得(初期表示)
    * @param serverData ユーザーリストのサーバ取得データ
    */
  public updateListingInfoList(serverData: any): void {
    if (serverData.ListingInfoList && serverData.ListingInfoList.Listing) {
      this.listingList = serverData.ListingInfoList.Listing;
      this.listingListTmp = this.listingList;

      const markList32: Array<any> = new Array<any>();
      for (let i = Number(0); i < this.listingList.length; i++) {
        const vo = {
          ListingItemID: PlessViewUtilsSub.trim(this.listingList[i].Div),
          ListingItemName: this.listingList[i].DivName,
          DispContents: '',
        };
        markList32.push(vo);
      }
      this.listingList = markList32;
    } else {
      this.listingList = null;
      this.listingListTmp = this.listingList;
    }
    this.setInitialFocus();
  }

  /**
    * pCode情報の表組タブ取得(検索後)
    * @param serverData ユーザーリストのサーバ取得データ
    */
  public updateListingList(serverData: any): void {
    if (serverData.GoodsListingList && serverData.GoodsListingList.List) {
      const goodsListingList = serverData.GoodsListingList.List;

      const markList32: Array<any> = new Array<any>();
      if (this.listingListTmp != null) {
        for (let i = Number(0); i < this.listingListTmp.length; i++) {
          const dispContents: string = this.isExistListingCode(goodsListingList, this.listingListTmp[i].Div);

          const vo = {
            ListingItemID: PlessViewUtilsSub.trim(this.listingListTmp[i].Div),
            ListingItemName: this.listingListTmp[i].DivName,
            DispContents: dispContents,
          };

          markList32.push(vo);
        }

        this.listingList = markList32;
      } else {
        this.listingList = null;
      }
    } else {
      const listingList32: Array<any> = new Array<any>();
      if (this.listingList != null) {
        for (let j = Number(0); j < this.listingList.length; j++) {
          const vo = {
            ListingItemID: PlessViewUtilsSub.trim(this.listingList[j].ListingItemID),
            ListingItemName: this.listingList[j].ListingItemName,
            DispContents: '',
          };

          listingList32.push(vo);
        }
        this.listingList = listingList32;
      } else {
        this.listingList = null;
      }
    }
  }

  private isExistListingCode(goodsListingList: Array<any>, itemID: string): string {
    for (let i = Number(0); i < goodsListingList.length; i++) {
      if (goodsListingList[i].ItemID === PlessViewUtilsSub.trim(itemID)) {
        if (goodsListingList[i].DispContents != null) {
          return goodsListingList[i].DispContents;
        } else {
          return '';
        }
      }
    }
    return '';
  }

  /**
    * PCode情報の商品DNA情報タブ取得(初期表示)
    * @param serverData ユーザーリストのサーバ取得データ
    */
  public updateDnaInfoList(serverData: any): void {
    // サーバから取得したデータにDNA情報が存在する場合
    if (serverData.DnaInfoList && serverData.DnaInfoList.DnaInfo) {
      // サーバ取得情報をリストに設定
      this.dnaList = serverData.DnaInfoList.DnaInfo;
      // 検索表示用にサーバ取得データを保持
      this.dnaListTmp = this.dnaList;

      // 画面表示用XMLを作成
      const dnaXmlList: Array<any> = new Array<any>();
      for (let i = Number(0); i < this.dnaList.length; i++) {
        const vo = {
          Check: false,
          DnaDiv: this.dnaList[i].DnaDiv,
          DnaName: this.dnaList[i].DnaDiv + ':' + this.dnaList[i].DnaName,
        };

        dnaXmlList.push(vo);
      }

      // 画面表示用XMLをリストに設定
      this.dnaList = dnaXmlList;
    } else {
      // サーバからの取得データが存在しない場合nullを設定
      // サーバ取得データが無いためnullをリストに設定
      this.dnaList = null;
      // 検索表示用にサーバ取得データを保持
      this.dnaListTmp = this.dnaList;
    }

    // フォーカスの設定
    this.setInitialFocus();
  }

  /**
    * PCode情報の商品DNA情報タブ取得(検索後)
    * @param serverData ユーザーリストのサーバ取得データ
    */
  public updateGoodsDnaList(serverData: any): void {
    let dnaInfoList: Array<any> = new Array<any>();
    const dnaXmlList: Array<any> = new Array<any>();

    // サーバから取得したデータにDNA情報が存在する場合
    if (serverData.GoodsDnaInfoList && serverData.GoodsDnaInfoList.List) {
      // サーバ取得情報をリストに設定
      dnaInfoList = serverData.GoodsDnaInfoList.List;
    }

    // 初期表示時のサーバ取得情報がnullでない場合
    if (this.dnaListTmp != null) {
      for (let i = Number(0); i < this.dnaListTmp.length; i++) {
        // チェックボックスを設定
        const check: boolean = this.isExistDnaDiv(dnaInfoList, this.dnaListTmp[i].DnaDiv);
        // 画面表示用XMLを作成
        const vo = {
          Check: check,
          DnaDiv: this.dnaListTmp[i].DnaDiv,
          DnaName: this.dnaListTmp[i].DnaDiv + ':' + this.dnaListTmp[i].DnaName,
        };
        dnaXmlList.push(vo);
      }
      // 画面表示用XMLをリストに設定
      this.dnaList = dnaXmlList;
    } else {
      // 初期表示情報が存在しない場合nullを設定
      this.dnaList = null;
    }
  }

  /**
    * アイテム情報の利用生協タブ取得(初期表示)
    * @param serverData ユーザーリストのサーバ取得データ
    */
  public updateGoodsDatailData(serverData: any): void {
    // Item基本情報
    this.itemList = serverData.ItemList.List;

    for (let i = Number(0); i < this.itemList.length; i++) {
      if (PlessViewUtilsSub.trim(this.itemList[i].ItemCode) === serverData.GoodsDetail.ItemCode) {
        this.itemCode = String(i);
      }
    }

    // アイテムコード（コピー用）出力
    this.itemCode = this.itemList[this.itemCode].ItemCode;

    this.janCode = serverData.GoodsDetail.JANCode;
    // JANCodeを8桁にするか13桁にするか判断する
    if (serverData.GoodsDetail.JANCodeDiv === 1) {
      this.janCodeDiv = true;
    } else {
      this.janCodeDiv = false;
    }

    // アイテムタブ
    this.kymw1100Component.cmb_BrandType.setCodeValue(serverData.GoodsDetail.BrandType);
    this.fcmcFee = serverData.GoodsDetail.FcmcFee;
    this.kymw1100Component.cmb_SpecialOrderTypeList.setCodeValue(serverData.GoodsDetail.SpecialOrderType);
    this.kymw1100Component.cmb_StockTypeList.setCodeValue(serverData.GoodsDetail.StockType);
    this.installmentTimes = serverData.GoodsDetail.InstallmentTimes;
    this.pdPilingUpDays = serverData.GoodsDetail.PdPilingUpDays;

    this.itfCode = serverData.GoodsDetail.ItfCode;
    this.kymw1100Component.cmb_OrderUnitType.setCodeValue(serverData.GoodsDetail.OrderUnitType);

    this.kymw1100Component.cmb_PriceType.setCodeValue(serverData.GoodsDetail.PriceType);
    this.makerPrice = serverData.GoodsDetail.MakerPrice;
    // 発注先取引先コード
    this.orderClientCode = serverData.GoodsDetail.OrderClientCode;
    // 発注先取引先停止区分
    this.tradeStopDivOrder = PlessViewUtilsSub.trim(serverData.GoodsDetail.OrderTradeStopDiv);
    // 発注先取引先名
    if (serverData.GoodsDetail.OrderClientName != null) {
      this.orderClientName = serverData.GoodsDetail.OrderClientName;
    } else {
      this.orderClientName = '';
    }
    // 支払先取引先コード
    this.payeeClientCode = serverData.GoodsDetail.PayeeClientCode;
    // 支払先取引先停止区分
    this.tradeStopDivPayee = PlessViewUtilsSub.trim(serverData.GoodsDetail.PayeeTradeStopDiv);
    // 支払先取引先名
    if (serverData.GoodsDetail.PayeeClientName != null) {
      this.payeeClientName = serverData.GoodsDetail.PayeeClientName;
    } else {
      this.payeeClientName = '';
    }
    this.fixContainNum = serverData.GoodsDetail.FixContainNum;
    this.setQuantity = serverData.GoodsDetail.SetQuantity;
    // 利用生協タブ
    this.bundlePrice = serverData.GoodsDetail.BundlePrice;

    // 仕様書1
    this.ebaseSpecCode = serverData.GoodsDetail.EbaseSpecCode;

    if (PlessViewUtilsSub.isEmpty(PlessViewUtilsSub.trim(serverData.GoodsDetail.SpecApplyDate))) {
      this.specApplyDate = '';
    } else {
      this.specApplyDate = serverData.GoodsDetail.SpecApplyDate;
    }
    this.ebaseGetDate = serverData.GoodsDetail.EbaseGetDate;

    this.registCatalogRound = serverData.GoodsDetail.RegistCatalogRound;
    this.makerName = serverData.GoodsDetail.MakerName;


    const makerNamePublishType = serverData.GoodsDetail.MakerNamePublishType;
    if (makerNamePublishType === '1') {
      this.makerNamePublishType = true;
    } else {
      this.makerNamePublishType = false;
    }

    this.peaceSizeLength = serverData.GoodsDetail.PeaceSizeLength;
    this.peaceSizeWidth = serverData.GoodsDetail.PeaceSizeWidth;
    this.peaceSizeHight = serverData.GoodsDetail.PeaceSizeHight;
    this.peaceSizeWeight = serverData.GoodsDetail.PeaceWeight;
    this.caseSizeLength = serverData.GoodsDetail.CaseSizeLength;
    this.caseSizeWidth = serverData.GoodsDetail.CaseSizeWidth;
    this.caseSizeHight = serverData.GoodsDetail.CaseSizeHight;
    this.caseSizeWeight = serverData.GoodsDetail.CaseWeight;
    this.kymw1100Component.cmb_GeneRecombinationDiv.setCodeValue(serverData.GoodsDetail.GeneRecombinationDiv);

    // ｅＢＡＳＥ仕様書コード（改訂）
    this.ebaseSpecCodeRev = serverData.GoodsDetail.EbaseSpecCodeRev;

    // 仕様書2
    this.kymw1100Component.cmb_AllergenTargetType.setCodeValue(serverData.GoodsDetail.AllergenTargetType);
    this.analysisUnit = serverData.GoodsDetail.AnalysisUnit;
    this.calorie = serverData.GoodsDetail.Calorie;
    this.protein = serverData.GoodsDetail.Protein;
    this.lipid = serverData.GoodsDetail.Lipid;
    this.carbohydrate = serverData.GoodsDetail.Carbohydrate;
    this.sodium = serverData.GoodsDetail.Sodium;

    this.updateDate = PlessViewUtilsSub.editDate(this.nullcheck(serverData.GoodsDetail.UpdateDate), '3');
    this.registDate = PlessViewUtilsSub.editDate(this.nullcheck(serverData.GoodsDetail.RegistDate), '3');
  }

  /**
    * アイテム情報の利用生協タブ取得(初期表示_設定チェック済表示)
    * @param serverData ユーザーリストのサーバ取得データ
    */
  public updateCheckCoopInfoList(serverData: any): void {
    if (serverData.CoopInfoList && serverData.CoopInfoList.Coop) {
      this.coopInfoList = serverData.CoopInfoList.Coop;

      this.coopInfoListTmp = this.coopInfoList;

      // 利用生協タブ全生協一括設定をチェック
      this.allCoop = true;
      const markList32: Array<any> = new Array<any>();
      for (let i = Number(0); i < this.coopInfoList.length; i++) {
        const vo = {
          Check: this.isKuruco(this.coopInfoList[i].Code) ? false : true,
          CoopCode: this.coopInfoList[i].Code,
          CoopName: this.coopInfoList[i].Name,
          CoopShortName: this.coopInfoList[i].ShortName,
          SupplyPriceStandard: '',
          SupplyPriceSpecial1: '',
          SupplyPriceSpecial2: '',
          SupplyTaxWithStd: '',
          SupplyTaxWithSpc1: '',
          SupplyTaxWithSpc2: '',
          CostPriceStandard: '',
          CostPriceSpecial1: '',
          CostPriceSpecial2: '',
          ConsignPriceStandard: '',
          ConsignPriceSpecial1: '',
          ConsignPriceSpecial2: '',
          ProducingAreaComment1: '',
          ProducingAreaComment2: '',
          Enabled: '0',
          ClassCode: this.kymw1100Component.checkClassCode(),
        };
        markList32.push(vo);
      }
      this.setCoopInfoList(markList32);
    } else {
      this.setCoopInfoList(null);
      this.coopInfoListTmp = null;
    }
    this.setInitialFocus();
  }

  /**
    * アイテム情報の利用生協タブ取得-税込みチェック(初期表示_設定チェック済表示)
    * Wkテーブルの初期値は取得しないため、CoopInfoList.Coopから「会員生協コード」,「会員生協名」,「略称」を取得
    * @param serverData ユーザーリストのサーバ取得データ
    */
  public updateCheckCoopWkInfoList(serverData: any): void {
    if (serverData.CoopInfoList && serverData.CoopInfoList.Coop) {
      this.coopInfoWkList = serverData.CoopInfoList.Coop;

      this.coopInfoWkListTmp = this.coopInfoWkList;

      const markList32: Array<any> = new Array<any>();
      for (let i = Number(0); i < this.coopInfoWkList.length; i++) {
        const vo = {
          Check: this.isKuruco(this.coopInfoWkList[i].Code) ? false : true,
          CoopCode: this.coopInfoWkList[i].Code,
          CoopName: this.coopInfoWkList[i].Name,
          CoopShortName: this.coopInfoWkList[i].ShortName,
          SupplyPriceStandard: '',
          SupplyPriceSpecial1: '',
          SupplyPriceSpecial2: '',
          SupplyTaxWithStd: '',
          SupplyTaxWithSpc1: '',
          SupplyTaxWithSpc2: '',
          CostPriceStandard: '',
          CostPriceSpecial1: '',
          CostPriceSpecial2: '',
          ConsignPriceStandard: '',
          ConsignPriceSpecial1: '',
          ConsignPriceSpecial2: '',
          ProducingAreaComment1: '',
          ProducingAreaComment2: '',
          Enabled: '0',
          ClassCode: this.kymw1100Component.checkClassCode(),

        };
        markList32.push(vo);
      }
      this.setCoopInfoWkList(markList32);
    } else {
      this.setCoopInfoWkList(null);
      this.coopInfoWkListTmp = null;
    }
  }

  /**
    * アイテム情報の利用生協タブ取得(初期表示)
    * @param serverData ユーザーリストのサーバ取得データ
    */
  public updateCoopInfoList(serverData: any): void {
    if (serverData.CoopInfoList && serverData.CoopInfoList.Coop) {
      this.coopInfoList = serverData.CoopInfoList.Coop;

      this.coopInfoListTmp = this.coopInfoList;

      const markList32: Array<any> = new Array<any>();
      for (let i = Number(0); i < this.coopInfoList.length; i++) {
        const vo = {
          Check: false,
          CoopCode: this.coopInfoList[i].Code,
          CoopName: this.coopInfoList[i].Name,
          CoopShortName: this.coopInfoList[i].ShortName,
          SupplyPriceStandard: '',
          SupplyPriceSpecial1: '',
          SupplyPriceSpecial2: '',
          SupplyTaxWithStd: '',
          SupplyTaxWithSpc1: '',
          SupplyTaxWithSpc2: '',
          CostPriceStandard: '',
          CostPriceSpecial1: '',
          CostPriceSpecial2: '',
          ConsignPriceStandard: '',
          ConsignPriceSpecial1: '',
          ConsignPriceSpecial2: '',
          ProducingAreaComment1: '',
          ProducingAreaComment2: '',
          Enabled: '0',
          ClassCode: this.kymw1100Component.checkClassCode(),
        };

        markList32.push(vo);

      }
      this.setCoopInfoList(markList32);
    } else {
      this.setCoopInfoList(null);
      this.coopInfoListTmp = null;
    }
    this.setInitialFocus();
  }

  /**
    * アイテム情報の利用生協タブ取得(検索後)
    * @param serverData ユーザーリストのサーバ取得データ
    */
  public updateGoodsCoopList(serverData: any): void {
    if (serverData.GoodsCoopList && serverData.GoodsCoopList.List) {
      const goodsCoopList = serverData.GoodsCoopList.List;

      const markList32: Array<any> = new Array<any>();
      if (this.coopInfoListTmp != null) {
        for (let i = Number(0); i < this.coopInfoListTmp.length; i++) {
          const check: boolean = this.isExistCoopCode(goodsCoopList, this.coopInfoListTmp[i].Code);

          const supplyPriceStandard: Array<any> = this.isExistCoop(goodsCoopList, this.coopInfoListTmp[i].Code);

          const enable: string = this.admitStatusCode(goodsCoopList, this.coopInfoListTmp[i].Code);

          const vo = {
            Check: check,
            CoopCode: this.coopInfoListTmp[i].Code,
            CoopName: this.coopInfoListTmp[i].Name,
            CoopShortName: this.coopInfoListTmp[i].ShortName,
            SupplyPriceStandard: supplyPriceStandard[0],
            SupplyPriceSpecial1: supplyPriceStandard[1],
            SupplyPriceSpecial2: supplyPriceStandard[2],
            SupplyTaxWithStd: '',
            SupplyTaxWithSpc1: '',
            SupplyTaxWithSpc2: '',
            CostPriceStandard: supplyPriceStandard[3],
            CostPriceSpecial1: supplyPriceStandard[4],
            CostPriceSpecial2: supplyPriceStandard[5],
            ConsignPriceStandard: supplyPriceStandard[6],
            ConsignPriceSpecial1: supplyPriceStandard[7],
            ConsignPriceSpecial2: supplyPriceStandard[8],
            ProducingAreaComment1: supplyPriceStandard[9],
            ProducingAreaComment2: supplyPriceStandard[10],
            Enabled: enable,
            ClassCode: this.kymw1100Component.checkClassCode(),
          };
          markList32.push(vo);
        }
        this.setCoopInfoList(markList32);
      } else {
        this.setCoopInfoList(null);
      }
    } else {
      const coopList32: Array<any> = new Array<any>();
      if (this.coopInfoList != null) {
        for (let j = Number(0); j < this.coopInfoList.length; j++) {
          const goodsNullXml = {
            Check: false,
            CoopCode: this.coopInfoList[j].CoopCode.constructor === Array
            ? this.coopInfoList[j].CoopCode : this.coopInfoList[j].CoopCode,
            CoopName: this.coopInfoList[j].CoopName.constructor === Array
            ? this.coopInfoList[j].CoopName : this.coopInfoList[j].CoopName,
            CoopShortName: this.coopInfoList[j].CoopShortName.constructor === Array
            ? this.coopInfoList[j].CoopShortName : this.coopInfoList[j].CoopShortName,
            SupplyPriceStandard: '',
            SupplyPriceSpecial1: '',
            SupplyPriceSpecial2: '',
            SupplyTaxWithStd: '',
            SupplyTaxWithSpc1: '',
            SupplyTaxWithSpc2: '',
            CostPriceStandard: '',
            CostPriceSpecial1: '',
            CostPriceSpecial2: '',
            ConsignPriceStandard: '',
            ConsignPriceSpecial1: '',
            ConsignPriceSpecial2: '',
            ProducingAreaComment1: '',
            ProducingAreaComment2: '',
            Enabled: '0',
            ClassCode: this.kymw1100Component.checkClassCode(),
          };

          coopList32.push(goodsNullXml);
        }
        this.setCoopInfoList(coopList32);
      } else {
        this.setCoopInfoList(null);
      }
    }
  }

  /**
    * アイテム情報Wkの利用生協タブ取得(検索後)
    * @param serverData ユーザーリストのサーバ取得データ
    */
  public updateGoodsCoopWkList(serverData: any): void {
    if (serverData.GoodsCoopWkList && serverData.GoodsCoopWkList.List) {
      const GoodsCoopList = serverData.GoodsCoopList.List;

      const GoodsCoopWkList = serverData.GoodsCoopWkList.List;

      const markList32: Array<any> = new Array<any>();
      if (this.coopInfoWkListTmp != null) {
        for (let i = Number(0); i < this.coopInfoWkListTmp.length; i++) {
          const check: boolean = this.isExistCoopCode(GoodsCoopWkList, this.coopInfoWkListTmp[i].Code);

          const supplyPriceStandard: Array<any> = this.isExistCoop(GoodsCoopList, this.coopInfoWkListTmp[i].Code);
          const supplyPriceStandardWk: Array<any> = this.isExistCoop(GoodsCoopWkList, this.coopInfoWkListTmp[i].Code);

          const enable: string = this.admitStatusCode(GoodsCoopWkList, this.coopInfoWkListTmp[i].Code);

          const vo = {
            Check: check,
            CoopCode: this.coopInfoWkListTmp[i].Code,
            CoopName: this.coopInfoWkListTmp[i].Name,
            CoopShortName: this.coopInfoWkListTmp[i].ShortName,
            SupplyPriceStandard: supplyPriceStandardWk[0],
            SupplyPriceSpecial1: supplyPriceStandardWk[1],
            SupplyPriceSpecial2: supplyPriceStandardWk[2],
            SupplyTaxWithStd: '',
            SupplyTaxWithSpc1: '',
            SupplyTaxWithSpc2: '',
            CostPriceStandard: supplyPriceStandardWk[3],
            CostPriceSpecial1: supplyPriceStandardWk[4],
            CostPriceSpecial2: supplyPriceStandardWk[5],
            ConsignPriceStandard: supplyPriceStandardWk[6],
            ConsignPriceSpecial1: supplyPriceStandardWk[7],
            ConsignPriceSpecial2: supplyPriceStandardWk[8],
            ProducingAreaComment1: supplyPriceStandard[9],
            ProducingAreaComment2: supplyPriceStandard[10],
            Enabled: enable,
            ClassCode: this.kymw1100Component.checkClassCode(),
          };
          markList32.push(vo);
        }
        this.setCoopInfoWkList(markList32);
      } else {
        this.setCoopInfoWkList(null);
      }
    } else {
      const coopList32: Array<any> = new Array<any>();
      if (this.coopInfoWkList != null) {
        for (let j = Number(0); j < this.coopInfoWkList.length; j++) {
          const goodsNullXml = {
            Check: false,
            CoopCode: this.coopInfoWkList[j].CoopCode.constructor === Array
            ? this.coopInfoWkList[j].CoopCode : this.coopInfoWkList[j].CoopCode,
            CoopName: this.coopInfoWkList[j].CoopName.constructor === Array
            ? this.coopInfoWkList[j].CoopName : this.coopInfoWkList[j].CoopName,
            CoopShortName: this.coopInfoWkList[j].CoopShortName.constructor === Array
            ? this.coopInfoWkList[j].CoopShortName : this.coopInfoWkList[j].CoopShortName,
            SupplyPriceStandard: '',
            SupplyPriceSpecial1: '',
            SupplyPriceSpecial2: '',
            SupplyTaxWithStd: '',
            SupplyTaxWithSpc1: '',
            SupplyTaxWithSpc2: '',
            CostPriceStandard: '',
            CostPriceSpecial1: '',
            CostPriceSpecial2: '',
            ConsignPriceStandard: '',
            ConsignPriceSpecial1: '',
            ConsignPriceSpecial2: '',
            ProducingAreaComment1: '',
            ProducingAreaComment2: '',
            Enabled: '0',
            ClassCode: this.kymw1100Component.checkClassCode(),
          };

          coopList32.push(goodsNullXml);
        }
        this.setCoopInfoWkList(coopList32);
      } else {
        this.setCoopInfoWkList(null);
      }
    }
  }

  /**
    * アイテム情報の利用生協タブ取得(商品検索後画面表示)
    * @param serverData ユーザーリストのサーバ取得データ
    */
  public updateCheckGoodsCoopList(serverData: any): void {
    if (serverData.GoodsCoopList && serverData.GoodsCoopList.List) {
      const markList32: Array<any> = new Array<any>();
      const goodsCoopList = serverData.GoodsCoopList.List;
      if (this.coopInfoListTmp != null) {
        for (let i = Number(0); i < this.coopInfoListTmp.length; i++) {
          const check: boolean = this.isExistCoopCode(goodsCoopList, this.coopInfoListTmp[i].Code);
          const supplyPriceStandard: Array<any> = this.isExistCoop(goodsCoopList, this.coopInfoListTmp[i].Code);
          const enable: string = this.admitStatusCode(goodsCoopList, this.coopInfoListTmp[i].Code);

          const vo = {
            Check: check,
            CoopCode: this.coopInfoListTmp[i].Code,
            CoopName: this.coopInfoListTmp[i].Name,
            CoopShortName: this.coopInfoListTmp[i].ShortName,
            SupplyPriceStandard: supplyPriceStandard[0],
            SupplyPriceSpecial1: supplyPriceStandard[1],
            SupplyPriceSpecial2: supplyPriceStandard[2],
            SupplyTaxWithStd: '',
            SupplyTaxWithSpc1: '',
            SupplyTaxWithSpc2: '',
            CostPriceStandard: supplyPriceStandard[3],
            CostPriceSpecial1: supplyPriceStandard[4],
            CostPriceSpecial2: supplyPriceStandard[5],
            ConsignPriceStandard: supplyPriceStandard[6],
            ConsignPriceSpecial1: supplyPriceStandard[7],
            ConsignPriceSpecial2: supplyPriceStandard[8],
            ProducingAreaComment1: supplyPriceStandard[9],
            ProducingAreaComment2: supplyPriceStandard[10],
            Enabled: enable,
            ClassCode: this.kymw1100Component.checkClassCode(),
          };
          markList32.push(vo);
        }
        this.setCoopInfoList(markList32);
      } else {
        this.setCoopInfoList(null);
      }
    } else {
      let initCheck: boolean;
      const coopList32: Array<any> = new Array<any>();
      if (this.coopInfoList != null) {
        if (this.admitStatus === '0') {
          this.allCoop = true;
          initCheck = true;
        } else {
          initCheck = false;
        }

        for (let j = Number(0); j < this.coopInfoList.length; j++) {
          const goodsNullXml = {
            Check: this.isKuruco(this.coopInfoList[j].CoopCode) ? false : initCheck,
            CoopCode: this.coopInfoList[j].CoopCode.constructor === Array
            ? this.coopInfoList[j].CoopCode : this.coopInfoList[j].CoopCode,
            CoopName: this.coopInfoList[j].CoopName.constructor === Array
            ? this.coopInfoList[j].CoopName : this.coopInfoList[j].CoopName,
            CoopShortName: this.coopInfoList[j].CoopShortName.constructor === Array
            ? this.coopInfoList[j].CoopShortName : this.coopInfoList[j].CoopShortName,
            SupplyPriceStandard: '',
            SupplyPriceSpecial1: '',
            SupplyPriceSpecial2: '',
            SupplyTaxWithStd: '',
            SupplyTaxWithSpc1: '',
            SupplyTaxWithSpc2: '',
            CostPriceStandard: '',
            CostPriceSpecial1: '',
            CostPriceSpecial2: '',
            ConsignPriceStandard: '',
            ConsignPriceSpecial1: '',
            ConsignPriceSpecial2: '',
            ProducingAreaComment1: '',
            ProducingAreaComment2: '',
            Enabled: '0',
            ClassCode: this.kymw1100Component.checkClassCode(),
          };

          coopList32.push(goodsNullXml);
        }
        this.setCoopInfoList(coopList32);
      } else {
        this.setCoopInfoList(null);
      }
    }
  }

  /**
    * Itemコードがある時にtrueを返す。
    */
  private isExistCoopCode(goodsCoopList: Array<any>, Code: string): boolean {

    for (let i = Number(0); i < goodsCoopList.length; i++) {
      if (goodsCoopList[i].CoopCode === Code) {
        return true;
      }
    }
    return false;
  }

  private isExistCoop(goodsCoopList: Array<any>, Code: string): Array<any> {
    const cooplist: Array<any> = ['', '', '', '', '', '', '', '', '', '', ''];

    for (let i = Number(0); i < goodsCoopList.length; i++) {
      if (goodsCoopList[i].CoopCode === Code) {
        cooplist[0] = this.nullcheck(goodsCoopList[i].SupplyPriceStandard);
        cooplist[1] = this.nullcheck(goodsCoopList[i].SupplyPriceSpecial1);
        cooplist[2] = this.nullcheck(goodsCoopList[i].SupplyPriceSpecial2);
        cooplist[3] = this.nullcheck(goodsCoopList[i].CostPriceStandard);
        cooplist[4] = this.nullcheck(goodsCoopList[i].CostPriceSpecial1);
        cooplist[5] = this.nullcheck(goodsCoopList[i].CostPriceSpecial2);
        cooplist[6] = this.nullcheck(goodsCoopList[i].ConsignPriceStandard);
        cooplist[7] = this.nullcheck(goodsCoopList[i].ConsignPriceSpecial1);
        cooplist[8] = this.nullcheck(goodsCoopList[i].ConsignPriceSpecial2);
        cooplist[9] = this.nullcheck(goodsCoopList[i].ProducingAreaComment1 ? goodsCoopList[i].ProducingAreaComment1 : '');
        cooplist[10] = this.nullcheck(goodsCoopList[i].ProducingAreaComment2 ? goodsCoopList[i].ProducingAreaComment2 : '');

        return cooplist;
      }
    }
    return cooplist;
  }

  private nullcheck(goodsCoop: string): string {
    if (goodsCoop != null) {
      return goodsCoop;
    }
    return '';
  }

  private admitStatusCode(goodsCoopList: Array<any>, Code: string): string {
    for (let i = Number(0); i < goodsCoopList.length; i++) {
      if (goodsCoopList[i].CoopCode === Code && this.admitStatus === '2') {
        return '2';
      }
    }
    return '0';
  }

  private isKuruco(coopCode: any) {
    const c = coopCode.constructor === Array ? coopCode : coopCode;
    return c === '454' ? true : false ;
  }

  /**
    * 利用生協金額表の描画更新
    * @param serverData ユーザーリストのサーバ取得データ
    */
  public viewUpdateSelectedCoopInfoList(_coopInfoList: Array<any>): void {
    this.coopInfoListScreen = _coopInfoList;
    if (this.isSelectedRateChangeMaster()) {
      this.coopInfoList = _coopInfoList;
    } else {
      this.coopInfoWkList = _coopInfoList;
    }
  }

  /**
    * pCode情報取得(CheckBoxイベント発生)
    * @param serverData ユーザーリストのサーバ取得データ
    */
  public updateSelectedCoopInfo(data: Object, _coopInfoList: Array<any>): void {
    let selectedVo: any;
    const newSelectedCoopList: Array<any> = new Array<any>();
    for (let i = Number(0); i < _coopInfoList.length; i++) {
      if (_coopInfoList[i].Check && _coopInfoList[i].ClassCode) {
        selectedVo = {
          Check: _coopInfoList[i].Check,
          CoopCode: _coopInfoList[i].CoopCode,
          CoopName: _coopInfoList[i].CoopName,
          CoopShortName: _coopInfoList[i].CoopShortName,
          SupplyPriceStandard: _coopInfoList[i].SupplyPriceStandard,
          SupplyPriceSpecial1: _coopInfoList[i].SupplyPriceSpecial1,
          SupplyPriceSpecial2: _coopInfoList[i].SupplyPriceSpecial2,
          SupplyTaxWithStd: this.getConsumePrice(_coopInfoList[i].SupplyPriceStandard),
          SupplyTaxWithSpc1: this.getConsumePrice(_coopInfoList[i].SupplyPriceSpecial1),
          SupplyTaxWithSpc2: this.getConsumePrice(_coopInfoList[i].SupplyPriceSpecial2),
          CostPriceStandard: _coopInfoList[i].CostPriceStandard,
          CostPriceSpecial1: _coopInfoList[i].CostPriceSpecial1,
          CostPriceSpecial2: _coopInfoList[i].CostPriceSpecial2,
          ConsignPriceStandard: _coopInfoList[i].ConsignPriceStandard,
          ConsignPriceSpecial1: _coopInfoList[i].ConsignPriceSpecial1,
          ConsignPriceSpecial2: _coopInfoList[i].ConsignPriceSpecial2,
          ProducingAreaComment1: this.producingAreaComment(_coopInfoList[i].ProducingAreaComment1),
          ProducingAreaComment2: this.producingAreaComment(_coopInfoList[i].ProducingAreaComment2),
          Enabled: _coopInfoList[i].Enabled,
          ClassCode: _coopInfoList[i].ClassCode,
        };

        newSelectedCoopList.push(selectedVo);
      } else if (_coopInfoList[i].Check && !_coopInfoList[i].ClassCode) {
        selectedVo = {
          Check: _coopInfoList[i].Check,
          CoopCode: _coopInfoList[i].CoopCode,
          CoopName: _coopInfoList[i].CoopName,
          CoopShortName: _coopInfoList[i].CoopShortName,
          SupplyPriceStandard: _coopInfoList[i].SupplyPriceStandard,
          SupplyPriceSpecial1: _coopInfoList[i].SupplyPriceSpecial1,
          SupplyPriceSpecial2: _coopInfoList[i].SupplyPriceSpecial2,
          SupplyTaxWithStd: this.getConsumePrice(_coopInfoList[i].SupplyPriceStandard),
          SupplyTaxWithSpc1: this.getConsumePrice(_coopInfoList[i].SupplyPriceSpecial1),
          SupplyTaxWithSpc2: this.getConsumePrice(_coopInfoList[i].SupplyPriceSpecial2),
          CostPriceStandard: _coopInfoList[i].CostPriceStandard,
          CostPriceSpecial1: _coopInfoList[i].CostPriceSpecial1,
          CostPriceSpecial2: _coopInfoList[i].CostPriceSpecial2,
          ConsignPriceStandard: _coopInfoList[i].ConsignPriceStandard,
          ConsignPriceSpecial1: _coopInfoList[i].ConsignPriceSpecial1,
          ConsignPriceSpecial2: _coopInfoList[i].ConsignPriceSpecial2,
          ProducingAreaComment1: _coopInfoList[i].ProducingAreaComment1,
          ProducingAreaComment2: _coopInfoList[i].ProducingAreaComment2,
          Enabled: _coopInfoList[i].Enabled,
          ClassCode: _coopInfoList[i].ClassCode,
        };

        newSelectedCoopList.push(selectedVo);
      } else {
        // 利用生協タブ全生協一括設定がチェックのとき、１個でも設定チェックが解除された場合
        // 利用生協タブ全生協一括設定のチェック解除
        if (this.allCoop) {
          this.allCoop = false;
        }

        selectedVo = {
          Check: _coopInfoList[i].Check,
          CoopCode: _coopInfoList[i].CoopCode,
          CoopName: _coopInfoList[i].CoopName,
          CoopShortName: _coopInfoList[i].CoopShortName,
          SupplyPriceStandard: '',
          SupplyPriceSpecial1: '',
          SupplyPriceSpecial2: '',
          SupplyTaxWithStd: '',
          SupplyTaxWithSpc1: '',
          SupplyTaxWithSpc2: '',
          CostPriceStandard: '',
          CostPriceSpecial1: '',
          CostPriceSpecial2: '',
          ConsignPriceStandard: '',
          ConsignPriceSpecial1: '',
          ConsignPriceSpecial2: '',
          ProducingAreaComment1: '',
          ProducingAreaComment2: '',
          Enabled: _coopInfoList[i].Enabled,
          ClassCode: _coopInfoList[i].ClassCode,
        };

        newSelectedCoopList.push(selectedVo);
      }

    }

    this.viewUpdateSelectedCoopInfoList(newSelectedCoopList);
  }

  /**
    * 産地コメント１が未設定の場合、「★★★★★★★★★★」を設定する。
    * 産地コメント２が未設定の場合、「★★★★★★★★★★」を設定する。
    */
  private producingAreaComment(goodsListing: string): string {
    if (PlessViewUtilsSub.isEmpty(goodsListing)) {
      return '★★★★★★★★★★';
    }
    return goodsListing;
  }

  /**
    * 利用生協のDataGirdでeventfocousOutイベント発生
    * 価格バンドル入力チェック処理を行う。
    * ①入力あり
    * 単品仕入価格（通常）×価格バンドルの計算値を仕入価格（通常）に表示する。
    */
  public updateConsignPriceStandard(list: any, data: any, afterFocusButton: ElementRef = null): void {
    const vo: Array<any> = ['', '', '', '', '', list];

    if (PlessViewUtilsSub.isEmpty(this.bundlePrice)) {
      vo[0] = '0';
    } else {
      vo[0] = this.bundlePrice;
    }
    vo[1] = data.CoopCode;
    vo[2] = data.CostPriceStandard;
    vo[3] = data.CostPriceSpecial1;
    vo[4] = data.CostPriceSpecial2;

    this.kymw1100Component.getPurchasePriceService.execute
      (this.kymw1100Component.kymw1100Model, vo, (serverData: any) => {
        // item情報
        this.setPurchasePriceFocouOut(vo[5], serverData);

        // フォーカスの指定がある場合は設定する
        if (afterFocusButton != null) {
          afterFocusButton.nativeElement.focus();
        }
      });

  }

  private checkNum(costPriceStandard: string): string {
    const bundlePrice = Number(this.bundlePrice);
    const returnStandard = Number(costPriceStandard);

    let tmp: Object;

    if (!PlessViewUtilsSub.isEmpty(costPriceStandard)) {
      tmp = Number(bundlePrice * returnStandard).toFixed(2);
      return String(tmp);
    }
    return '';
  }

  /**
    * * 利用生協の一括反映ボタンイベント
    * @param serverData ユーザーリストのサーバ取得データ
    */
  public setPurchasePrice(serverData: any): void {
    let costPriceStandard = '';
    if (serverData.PurchasePriceStandard != null) {
      costPriceStandard = serverData.PurchasePriceStandard;
    } else {
      costPriceStandard = '';
    }

    let costPriceSpecial1 = '';
    if (serverData.PurchasePriceSpecial1 != null) {
      costPriceSpecial1 = serverData.PurchasePriceSpecial1;
    } else {
      costPriceSpecial1 = '';
    }

    let costPriceSpecial2 = '';
    if (serverData.PurchasePriceSpecial2 != null) {
      costPriceSpecial2 = serverData.PurchasePriceSpecial2;
    } else {
      costPriceSpecial2 = '';
    }

    const markList32: Array<any> = new Array<any>();
    let vo;
    if (this.coopInfoListScreen != null) {
      for (let i = Number(0); i < this.coopInfoListScreen.length; i++) {
        if (this.coopInfoListScreen[i].Check) {
          vo = {
            Check: this.coopInfoListScreen[i].Check,
            CoopCode: this.coopInfoListScreen[i].CoopCode.constructor === Array
            ? this.coopInfoListScreen[i].CoopCode : this.coopInfoListScreen[i].CoopCode,
            CoopName: this.coopInfoListScreen[i].CoopName.constructor === Array
            ? this.coopInfoListScreen[i].CoopName : this.coopInfoListScreen[i].CoopName,
            CoopShortName: this.coopInfoListScreen[i].CoopShortName.constructor === Array
            ? this.coopInfoListScreen[i].CoopShortName : this.coopInfoListScreen[i].CoopShortName,
            SupplyPriceStandard: this.getValue(this.supplyPriceCoefficient, i, 'SupplyPriceStandard'),
            SupplyPriceSpecial1: this.getValue(this.supplyPriceSpecial1, i, 'SupplyPriceSpecial1'),
            SupplyPriceSpecial2: this.getValue(this.supplyPriceSpecial2, i, 'SupplyPriceSpecial2'),
            SupplyTaxWithStd: this.getConsumePrice(this.getValue(this.supplyPriceCoefficient, i, 'SupplyPriceStandard')),
            SupplyTaxWithSpc1: this.getConsumePrice(this.getValue(this.supplyPriceSpecial1, i, 'SupplyPriceSpecial1')),
            SupplyTaxWithSpc2: this.getConsumePrice(this.getValue(this.supplyPriceSpecial2, i, 'SupplyPriceSpecial2')),
            CostPriceStandard: this.getValue(this.costPricecoefficient, i, 'CostPriceStandard'),
            CostPriceSpecial1: this.getValue(this.texi_costPriceSpecial1, i, 'CostPriceSpecial1'),
            CostPriceSpecial2: this.getValue(this.texi_costPriceSpecial2, i, 'CostPriceSpecial2'),
            ConsignPriceStandard: this.getValue(costPriceStandard, i, 'ConsignPriceStandard'),
            ConsignPriceSpecial1: this.getValue(costPriceSpecial1, i, 'ConsignPriceSpecial1'),
            ConsignPriceSpecial2: this.getValue(costPriceSpecial2, i, 'ConsignPriceSpecial2'),
            ProducingAreaComment1: this.coopInfoListScreen[i].ProducingAreaComment1,
            ProducingAreaComment2: this.coopInfoListScreen[i].ProducingAreaComment2,
            Enabled: this.coopInfoListScreen[i].Enabled,
            ClassCode: this.coopInfoListScreen[i].ClassCode,
          };

          markList32.push(vo);
        } else {
          vo = {
            Check: this.coopInfoListScreen[i].Check,
            CoopCode: this.coopInfoListScreen[i].CoopCode.constructor === Array
            ? this.coopInfoListScreen[i].CoopCode : this.coopInfoListScreen[i].CoopCode,
            CoopName: this.coopInfoListScreen[i].CoopName.constructor === Array
            ? this.coopInfoListScreen[i].CoopName : this.coopInfoListScreen[i].CoopName,
            CoopShortName: this.coopInfoListScreen[i].CoopShortName.constructor === Array
            ? this.coopInfoListScreen[i].CoopShortName : this.coopInfoListScreen[i].CoopShortName,
            SupplyPriceStandard: this.coopInfoListScreen[i].SupplyPriceStandard,
            SupplyPriceSpecial1: this.coopInfoListScreen[i].SupplyPriceSpecial1,
            SupplyPriceSpecial2: this.coopInfoListScreen[i].SupplyPriceSpecial2,
            SupplyTaxWithStd: this.coopInfoListScreen[i].SupplyPriceStandard,
            SupplyTaxWithSpc1: this.coopInfoListScreen[i].SupplyPriceSpecial1,
            SupplyTaxWithSpc2: this.coopInfoListScreen[i].SupplyPriceSpecial2,
            CostPriceStandard: this.coopInfoListScreen[i].CostPriceStandard,
            CostPriceSpecial1: this.coopInfoListScreen[i].CostPriceSpecial1,
            CostPriceSpecial2: this.coopInfoListScreen[i].CostPriceSpecial2,
            ConsignPriceStandard: this.coopInfoListScreen[i].ConsignPriceStandard,
            ConsignPriceSpecial1: this.coopInfoListScreen[i].ConsignPriceSpecial1,
            ConsignPriceSpecial2: this.coopInfoListScreen[i].ConsignPriceSpecial2,
            ProducingAreaComment1: this.coopInfoListScreen[i].ProducingAreaComment1,
            ProducingAreaComment2: this.coopInfoListScreen[i].ProducingAreaComment2,
            Enabled: this.coopInfoListScreen[i].Enabled,
            ClassCode: this.coopInfoListScreen[i].ClassCode,
          };

          markList32.push(vo);
        }
      }
      this.viewUpdateSelectedCoopInfoList(markList32);
    } else {
      this.viewUpdateSelectedCoopInfoList(null);
    }
  }

  /**
    * 利用生協のタブ画面の入力内容を取得してArrayCollectionで返却
    * @return 価格の入力内容
    */
  public getCoopConsumeTaxPrice(): Array<any> {
    let vo: any;
    const markList32: Array<any> = new Array<any>();
    const selectedListTemp: Array<any> = this.getEditCoopInfoList();
    if (this.coopInfoListScreen != null) {
      for (let i = Number(0); i < this.coopInfoListScreen.length; i++) {
        if (this.coopInfoListScreen[i].Check) {
          vo = {
            Check: this.coopInfoListScreen[i].Check,
            CoopCode: this.coopInfoListScreen[i].CoopCode,
            CoopName: this.coopInfoListScreen[i].CoopName,
            CoopShortName: this.coopInfoListScreen[i].CoopShortName,
            SupplyPriceStandard: this.coopInfoListScreen[i].SupplyPriceStandard,
            SupplyPriceSpecial1: this.coopInfoListScreen[i].SupplyPriceSpecial1,
            SupplyPriceSpecial2: this.coopInfoListScreen[i].SupplyPriceSpecial2,
            SupplyTaxWithStd: this.coopInfoListScreen[i].SupplyTaxWithStd,
            SupplyTaxWithSpc1: this.coopInfoListScreen[i].SupplyTaxWithSpc1,
            SupplyTaxWithSpc2: this.coopInfoListScreen[i].SupplyTaxWithSpc2,
            CostPriceStandard: this.coopInfoListScreen[i].CostPriceStandard,
            CostPriceSpecial1: this.coopInfoListScreen[i].CostPriceSpecial1,
            CostPriceSpecial2: this.coopInfoListScreen[i].CostPriceSpecial2,
            ConsignPriceStandard: this.coopInfoListScreen[i].ConsignPriceStandard,
            ConsignPriceSpecial1: this.coopInfoListScreen[i].ConsignPriceSpecial1,
            ConsignPriceSpecial2: this.coopInfoListScreen[i].ConsignPriceSpecial2,
            ProducingAreaComment1: this.coopInfoListScreen[i].ProducingAreaComment1,
            ProducingAreaComment2: this.coopInfoListScreen[i].ProducingAreaComment2,
            Enabled: this.coopInfoListScreen[i].Enabled,
            ClassCode: this.coopInfoListScreen[i].ClassCode,
          };

          markList32.push(vo);
        } else {
          vo = {
            Check: this.coopInfoListScreen[i].Check,
            CoopCode: selectedListTemp[i].CoopCode,
            CoopName: selectedListTemp[i].CoopName,
            CoopShortName: selectedListTemp[i].CoopShortName,
            SupplyPriceStandard: selectedListTemp[i].SupplyPriceStandard,
            SupplyPriceSpecial1: selectedListTemp[i].SupplyPriceSpecial1,
            SupplyPriceSpecial2: selectedListTemp[i].SupplyPriceSpecial2,
            SupplyTaxWithStd: selectedListTemp[i].SupplyTaxWithStd,
            SupplyTaxWithSpc1: selectedListTemp[i].SupplyTaxWithSpc1,
            SupplyTaxWithSpc2: selectedListTemp[i].SupplyTaxWithSpc2,
            CostPriceStandard: selectedListTemp[i].CostPriceStandard,
            CostPriceSpecial1: selectedListTemp[i].CostPriceSpecial1,
            CostPriceSpecial2: selectedListTemp[i].CostPriceSpecial2,
            ConsignPriceStandard: selectedListTemp[i].ConsignPriceStandard,
            ConsignPriceSpecial1: selectedListTemp[i].ConsignPriceSpecial1,
            ConsignPriceSpecial2: selectedListTemp[i].ConsignPriceSpecial2,
            ProducingAreaComment1: selectedListTemp[i].ProducingAreaComment1,
            ProducingAreaComment2: selectedListTemp[i].ProducingAreaComment2,
            Enabled: selectedListTemp[i].Enabled,
            ClassCode: selectedListTemp[i].ClassCode,
          };

          markList32.push(vo);
        }
      }
    }

    return markList32;
  }

  /**
    * 消費税区分、消費税率を画面から取得してローカル保存する
    */
  public saveConsumeTaxDivAndRate(): void {
    if (this.isSelectedRateChangeMaster()) {

      this.consumeTaxDivList = PlessViewUtilsSub.trim(this.kymw1100Component.cmb_ConsumeTaxDivList.selectedCodeValue);
      this.consumeTaxDivRate = this.consumeTaxDivRateScreen;
    } else {
      this.consumeTaxDivWk = PlessViewUtilsSub.trim(this.kymw1100Component.cmb_ConsumeTaxDivList.selectedCodeValue);
      this.consumeTaxRateWk = this.consumeTaxDivRateScreen;
    }
  }

  /**
    * 消費税切り替えで対象となっている、消費税区分を取得
    */
  public getTargetConsumeTaxDiv(): string {
    if (this.isSelectedRateChangeMaster()) {
      return this.consumeTaxDivList;
    }
    return this.consumeTaxDivWk;
  }

  /**
    * 消費税切り替えで対象となっている、消費税率を取得
    */
  public getTargetConsumeTaxRate(): string {
    if (this.isSelectedRateChangeMaster()) {
      return this.consumeTaxDivRate;
    }

    return this.consumeTaxRateWk;
  }

  /**
    * 利用生協のタブ画面の入力内容をローカルに保存する
    * 税率切り替えコンボボックスの選択内容によって保存先を変更する。
    * @return なし
    */
  public savedCoopConsumeTaxPrice(): void {
    const list: Array<any> = this.getCoopConsumeTaxPrice();

    if (this.getEditCoopInfoList() === this.coopInfoList) {
      this.coopInfoList = list;

      // マスタで編集したチェックとコメントをWkへコピー
      for (let i = Number(0); i < this.coopInfoWkList.length; i++) {
        this.coopInfoWkList[i]['Check'] = this.coopInfoList[i]['Check'];

        this.coopInfoWkList[i]['ProducingAreaComment1'] = this.coopInfoList[i]['ProducingAreaComment1'];
        this.coopInfoWkList[i]['ProducingAreaComment2'] = this.coopInfoList[i]['ProducingAreaComment2'];
      }
    } else {
      this.coopInfoWkList = list;

      // Wkで編集したチェックとコメントをマスタへコピー
      for (let j = Number(0); j < this.coopInfoWkList.length; j++) {
        this.coopInfoList[j]['Check'] = this.coopInfoWkList[j]['Check'];

        this.coopInfoList[j]['ProducingAreaComment1'] = this.coopInfoWkList[j]['ProducingAreaComment1'];
        this.coopInfoList[j]['ProducingAreaComment2'] = this.coopInfoWkList[j]['ProducingAreaComment2'];
      }

    }
  }

  /**
    * 消費税区分変更後の価格計算イベント
    * 表示中の消費税区分、消費税率を元に会員生協毎の商品価格を計算する。
    *
    * 描画更新しない利用を想定（coopInfoListScreenを引数に指定しない）
    * @param _coopInfoList: coopInfoListまたはcoopInfoWkList
    */
  public setConsumeTaxPrice(_coopInfoList: Array<any>): void {
    let vo: any;
    const markList32: Array<any> = new Array<any>();

    if (_coopInfoList != null) {
      for (let i = Number(0); i < _coopInfoList.length; i++) {
        if (_coopInfoList[i].Check) {
          vo = {
            Check: _coopInfoList[i].Check,
            CoopCode: _coopInfoList[i].CoopCode,
            CoopName: _coopInfoList[i].CoopName,
            CoopShortName: _coopInfoList[i].CoopShortName,

            SupplyPriceStandard: _coopInfoList[i].SupplyPriceStandard,
            SupplyPriceSpecial1: _coopInfoList[i].SupplyPriceSpecial1,
            SupplyPriceSpecial2: _coopInfoList[i].SupplyPriceSpecial2,
            SupplyTaxWithStd: this.getConsumePrice(_coopInfoList[i].SupplyPriceStandard),
            SupplyTaxWithSpc1: this.getConsumePrice(_coopInfoList[i].SupplyPriceSpecial1),
            SupplyTaxWithSpc2: this.getConsumePrice(_coopInfoList[i].SupplyPriceSpecial2),
            CostPriceStandard: _coopInfoList[i].CostPriceStandard,
            CostPriceSpecial1: _coopInfoList[i].CostPriceSpecial1,
            CostPriceSpecial2: _coopInfoList[i].CostPriceSpecial2,
            ConsignPriceStandard: _coopInfoList[i].ConsignPriceStandard,
            ConsignPriceSpecial1: _coopInfoList[i].ConsignPriceSpecial1,
            ConsignPriceSpecial2: _coopInfoList[i].ConsignPriceSpecial2,

            ProducingAreaComment1: _coopInfoList[i].ProducingAreaComment1,
            ProducingAreaComment2: _coopInfoList[i].ProducingAreaComment2,
            Enabled: _coopInfoList[i].Enabled,
            ClassCode: _coopInfoList[i].ClassCode,
          };

          markList32.push(vo);
        } else {
          vo = {
            Check: _coopInfoList[i].Check,
            CoopCode: _coopInfoList[i].CoopCode,
            CoopName: _coopInfoList[i].CoopName,
            CoopShortName: _coopInfoList[i].CoopShortName,

            SupplyPriceStandard: '',
            SupplyPriceSpecial1: '',
            SupplyPriceSpecial2: '',
            SupplyTaxWithStd: '',
            SupplyTaxWithSpc1: '',
            SupplyTaxWithSpc2: '',
            CostPriceStandard: '',
            CostPriceSpecial1: '',
            CostPriceSpecial2: '',
            ConsignPriceStandard: '',
            ConsignPriceSpecial1: '',
            ConsignPriceSpecial2: '',

            ProducingAreaComment1: _coopInfoList[i].ProducingAreaComment1,
            ProducingAreaComment2: _coopInfoList[i].ProducingAreaComment2,
            Enabled: _coopInfoList[i].Enabled,
            ClassCode: _coopInfoList[i].ClassCode,
          };

          markList32.push(vo);
        }
      }
      _coopInfoList = markList32;
    } else {
      _coopInfoList = null;
    }

    this.viewUpdateSelectedCoopInfoList(_coopInfoList);

  }

  /**
    * 税抜き価格計算
    *
    * @param standardPrice 税抜き価格
    */
  public getConsumePriceWithoutTax(codeValueTaxDiv: string, consumeTaxDivRate: string, price: string): string {
    let consumeTaxPrice: string = <string>'';
    let num: number;

    // 消費税区分の判定
    if (codeValueTaxDiv === '9') {
      const tax = Number(consumeTaxDivRate);

      // 0:内税の場合：供給価格 -　(供給価格 / (100 + 税率) * 税率)
      num = Number(price) - (Number(price) / (100 + tax)) * tax;

      num = Math.round(num * 10) / 10;

      consumeTaxPrice = String(Math.round(num * 100) / 100);
    } else {
      // 0:内税以外の場合、本体価格をそのまま設定
      consumeTaxPrice = price;
    }
    return consumeTaxPrice;
  }

  /**
    * 税込価格計算設定
    * 現在の表示内容の消費税区分、消費税率で計算します。
    *
    * ※: 表示している消費税区分、消費税率で計算するため表示更新以外での使用不可
    *
    * @param standardPrice 本体価格
    */
  public getConsumePrice(standardPrice: string): string {
    let consumeTaxPrice: string = <string>'';
    let _consumeTaxDivRate: string = <string>'';

    _consumeTaxDivRate = this.consumeTaxDivRateScreen;

    // 消費税区分の判定
    if (this.kymw1100Component.cmb_ConsumeTaxDivList.selectedCodeValue === '0') {
      // 0:外税の場合、消費税率にて税込価格を算出
      if (standardPrice.length > 0) {
        consumeTaxPrice = String((Number(standardPrice) + (Number(standardPrice) * (Number(_consumeTaxDivRate) / 100))));
      }
    } else {
      // 0:外税以外の場合、本体価格をそのまま設定
      consumeTaxPrice = standardPrice;
    }
    return consumeTaxPrice;
  }

  /**
    * 利用生協の一括反映ボタンの
    * @param str : 画面で入力された情報
    * @param i   : 列の順番をもらう
    * @param div : 利用生協の項目名
    *
    * return :string
    */
  public getValue(str: string, i: number, div: string): string {
    switch (div) {
      case 'SupplyPriceStandard':
        if (PlessViewUtilsSub.isEmpty(str)) {
          if (this.ratechangeBox === '01') {
            return this.coopInfoList[i].SupplyPriceStandard;
          } else if (this.ratechangeBox === '02') {
            return this.coopInfoWkList[i].SupplyPriceStandard;
          } else {
            return this.coopInfoListScreen[i].SupplyPriceStandard;
          }
        } else {
          return str;
        }
        break;
      case 'SupplyPriceSpecial1':
        if (PlessViewUtilsSub.isEmpty(str)) {
          if (this.ratechangeBox === '01') {
            return this.coopInfoList[i].SupplyPriceSpecial1;
          } else if (this.ratechangeBox === '02') {
            return this.coopInfoWkList[i].SupplyPriceSpecial1;
          } else {
            return this.coopInfoListScreen[i].SupplyPriceSpecial1;
          }
        } else {
          return str;
        }
        break;
      case 'SupplyPriceSpecial2':
        if (PlessViewUtilsSub.isEmpty(str)) {
          if (this.ratechangeBox === '01') {
            return this.coopInfoList[i].SupplyPriceSpecial2;
          } else if (this.ratechangeBox === '02') {
            return this.coopInfoWkList[i].SupplyPriceSpecial2;
          } else {
            return this.coopInfoListScreen[i].SupplyPriceSpecial2;
          }
        } else {
          return str;
        }
        break;
      case 'CostPriceStandard':
        if (PlessViewUtilsSub.isEmpty(str)) {
          if (this.ratechangeBox === '01') {
            return this.coopInfoList[i].CostPriceStandard;
          } else if (this.ratechangeBox === '02') {
            return this.coopInfoWkList[i].CostPriceStandard;
          } else {
            return this.coopInfoListScreen[i].CostPriceStandard;
          }
        } else {
          return str;
        }
      case 'CostPriceSpecial1':
        if (PlessViewUtilsSub.isEmpty(str)) {
          if (this.ratechangeBox === '01') {
            return this.coopInfoList[i].CostPriceSpecial1;
          } else if (this.ratechangeBox === '02') {
            return this.coopInfoWkList[i].CostPriceSpecial1;
          } else {
            return this.coopInfoListScreen[i].CostPriceSpecial1;
          }
        } else {
          return str;
        }
        break;
      case 'CostPriceSpecial2':
        if (PlessViewUtilsSub.isEmpty(str)) {
          if (this.ratechangeBox === '01') {
            return this.coopInfoList[i].CostPriceSpecial2;
          } else if (this.ratechangeBox === '02') {
            return this.coopInfoWkList[i].CostPriceSpecial2;
          } else {
            return this.coopInfoListScreen[i].CostPriceSpecial2;
          }
        } else {
          return str;
        }
        break;
      case 'ConsignPriceStandard':
        if (PlessViewUtilsSub.isEmpty(str)) {
          if (this.ratechangeBox === '01') {
            return this.coopInfoList[i].ConsignPriceStandard;
          } else if (this.ratechangeBox === '02') {
            return this.coopInfoWkList[i].ConsignPriceStandard;
          } else {
            return this.coopInfoListScreen[i].ConsignPriceStandard;
          }
        } else {
          return str;
        }
        break;
      case 'ConsignPriceSpecial1':
        if (PlessViewUtilsSub.isEmpty(str)) {
          if (this.ratechangeBox === '01') {
            return this.coopInfoList[i].ConsignPriceSpecial1;
          } else if (this.ratechangeBox === '02') {
            return this.coopInfoWkList[i].ConsignPriceSpecial1;
          } else {
            return this.coopInfoListScreen[i].ConsignPriceSpecial1;
          }
        } else {
          return str;
        }
        break;
      case 'ConsignPriceSpecial2':
        if (PlessViewUtilsSub.isEmpty(str)) {
          if (this.ratechangeBox === '01') {
            return this.coopInfoList[i].ConsignPriceSpecial2;
          } else if (this.ratechangeBox === '02') {
            return this.coopInfoWkList[i].ConsignPriceSpecial2;
          } else {
            return this.coopInfoListScreen[i].ConsignPriceSpecial2;
          }
        } else {
          return str;
        }
        break;
      default: return str;
    }
  }

  /**
    * 仕入価格計算
    * @param serverData ユーザーリストのサーバ取得データ
    */
  public setPurchasePriceFocouOut(_coopInfoList: Array<any>, serverData: any): void {
    if (serverData.PurchasePriceStandard != null) {
      this.costPriceStandard = serverData.PurchasePriceStandard;
    } else {
      this.costPriceStandard = '';
    }

    if (serverData.PurchasePriceSpecial1 != null) {
      this.costPriceSpecial1 = serverData.PurchasePriceSpecial1;
    } else {
      this.costPriceSpecial1 = '';
    }

    if (serverData.PurchasePriceSpecial2 != null) {
      this.costPriceSpecial2 = serverData.PurchasePriceSpecial2;
    } else {
      this.costPriceSpecial2 = '';
    }

    for (let i = Number(0); i < _coopInfoList.length; i++) {
      if (_coopInfoList[i].Check) {
        if (_coopInfoList[i].CoopCode === serverData.CoopCode) {
          _coopInfoList[i].ConsignPriceStandard = this.costPriceStandard;
          _coopInfoList[i].ConsignPriceSpecial1 = this.costPriceSpecial1;
          _coopInfoList[i].ConsignPriceSpecial2 = this.costPriceSpecial2;
          return;
        }
      }
    }
  }

  /**
    * アイテム情報の仕様書2タブ取得(初期表示)
    * @param serverData ユーザーリストのサーバ取得データ
    */
  public updateSpecifications1List(serverData: any): void {
    if (serverData.Specifications1List && serverData.Specifications1List.List) {
      const specifications1List = serverData.Specifications1List.List;

      for (let i = Number(0); i < specifications1List.length; i++) {
        switch (specifications1List[i].TextInfoDiv) {
          // アイテム項目
          case '005':
            this.textInfoDiv1 = specifications1List[i].TextInfoDiv;
            this.stringValue1 = specifications1List[i].StringValue;
            break;
          case '014':
            this.textInfoDiv2 = specifications1List[i].TextInfoDiv;
            this.stringValue2 = specifications1List[i].StringValue;
            break;
          case '013':
            this.textInfoDiv3 = specifications1List[i].TextInfoDiv;
            this.stringValue3 = specifications1List[i].StringValue;
            break;
          case '010':
            this.textInfoDiv4 = specifications1List[i].TextInfoDiv;
            this.stringValue4 = specifications1List[i].StringValue;
            break;
          case '006':
            this.textInfoDiv5 = specifications1List[i].TextInfoDiv;
            this.stringValue5 = specifications1List[i].StringValue;
            break;
          case '007':
            this.textInfoDiv6 = specifications1List[i].TextInfoDiv;
            this.stringValue6 = specifications1List[i].StringValue;
            break;
        }
      }
    }
  }

  /**
    * アイテム情報の仕様書2タブ取得(初期表示)
    * @param serverData ユーザーリストのサーバ取得データ
    */
  public updateAllergenInfoList(serverData: any): void {
    if (serverData.AllergenInfoList && serverData.AllergenInfoList.Allergen) {
      this.allergenList = serverData.AllergenInfoList.Allergen;

      this.allergenListTmp = this.allergenList;

      const markList32: Array<any> = new Array<any>();
      for (let i = Number(0); i < this.allergenList.length; i++) {
        const vo = {
          Check: false,
          AllergenCode: this.allergenList[i].Div,
          AllergenName: this.allergenList[i].Name,
          PublishDiv: this.allergenList[i].PublishDiv,
          ComponentCheck: false
        };

        markList32.push(vo);
      }

      this.allergenList = markList32;
    } else {
      this.allergenList = null;
      this.allergenListTmp = this.allergenList;
    }
    this.setInitialFocus();
  }

  /**
    * アイテム情報の仕様書2タブ取得(検索後)
    * @param serverData ユーザーリストのサーバ取得データ
    */
  public updateGoodsAllergenList(serverData: any): void {
    let goodsAllenrgenList: Array<any> = new Array<any>();
    let goodsComponentAllergenList: Array<any> = new Array<any>();
    const markList32: Array<any> = new Array<any>();

    if (serverData.GoodsAllergenList && serverData.GoodsAllergenList.List) {
      goodsAllenrgenList = serverData.GoodsAllergenList.List;
    }
    if (serverData.GoodsComponentAllergenList && serverData.GoodsComponentAllergenList.List) {
      goodsComponentAllergenList = serverData.GoodsComponentAllergenList.List;
    }

    if (this.allergenListTmp != null) {
      for (let i = Number(0); i < this.allergenListTmp.length; i++) {
        const check: boolean = this.isExistAllergenDiv(goodsAllenrgenList, this.allergenListTmp[i].Div);
        const componentAllergenCheck: boolean = this.isExistAllergenDiv(goodsComponentAllergenList, this.allergenListTmp[i].Div);

        const vo = {
          Check: check,
          AllergenCode: this.allergenListTmp[i].Div,
          AllergenName: this.allergenListTmp[i].Name,
          PublishDiv: this.allergenListTmp[i].PublishDiv,
          ComponentCheck: componentAllergenCheck,
        };
        markList32.push(vo);
      }
      this.allergenList = markList32;
    } else {
      this.allergenList = null;
    }
  }

  /**
    * Pコードがある時にtrueを返す。
    */
  private isExistAllergenDiv(allergenList: Array<any>, allergenDiv: string): boolean {
    for (let i = Number(0); i < allergenList.length; i++) {
      if (allergenList[i].AllergenCode === allergenDiv) {
        return true;
      }
    }
    return false;
  }

  /**
    * Pコードがある時にtrueを返す。（初期表示）
    */
  private isExistDnaDiv(dnaList: Array<any>, dnaDiv: string): boolean {
    for (let i = Number(0); i < dnaList.length; i++) {
      // サーバ取得情報と初期表示情報の区分を比較
      if (dnaList[i].GoodsDnaDiv === dnaDiv) {
        // 一致した場合、チェックボックスを選択済みに設定するためtrueを返す
        return true;
      }
    }
    return false;
  }

  /**
    * アイテム情報の環境関連タブ取得(初期表示)
    * 環境区分
    * @param serverData ユーザーリストのサーバ取得データ
    */
  public updateEcologyInfoList(serverData: any): void {
    if (serverData.EcologyInfoList && serverData.EcologyInfoList.Ecology) {
      this.goodsEcologyList = serverData.EcologyInfoList.Ecology;

      this.goodsEcologyListTmp = this.goodsEcologyList;

      const markList32: Array<any> = new Array<any>();
      for (let i = Number(0); i < this.goodsEcologyList.length; i++) {
        if (PlessViewUtilsSub.trim(this.goodsEcologyList[i].Div) === '00') {
          this.ecology = '1';
        } else {
          const vo = {
            Check: false,
            EcologyDiv: this.goodsEcologyList[i].Div,
            EcologyName: this.goodsEcologyList[i].Name,
            Enabled: false,
          };

          markList32.push(vo);
        }
      }

      this.goodsEcologyList = markList32;
    } else {
      this.goodsEcologyList = null;
      this.goodsEcologyListTmp = this.goodsEcologyList;
    }
    this.setInitialFocus();
  }

  /**
    * アイテム情報の栄養成分タブ取得(検索後)
    * @param serverData ユーザーリストのサーバ取得データ
    */
  public updateGoodsNutrientInfo(serverData: any): void {
    let vo: any;

    // 誌面栄養成分情報
    if (serverData.NutrientInfoList && (0 < serverData.NutrientInfoList.List?.length)) {
      const nutrientInfoList: Array<any> = serverData.NutrientInfoList.List;
      // 分析単位
      const unitList: Array<any> = new Array<any>();
      vo = {
        AnalysisUnit: nutrientInfoList[0].AnalysisUnit,
      };
      unitList.push(vo);
      this.nutrientUnitList = unitList;
      // 栄養成分
      const nutrientComponentList = nutrientInfoList[0].NutrientComponentList.List;
      const component: Array<any> = new Array<any>();
      for (let i = Number(0); i < nutrientComponentList.length; i++) {
        vo = {
          NutritionalName: nutrientComponentList[i].NutritionalName,
          NutritionalQuantity: nutrientComponentList[i].NutritionalQuantity === null
            ? '' : nutrientComponentList[i].NutritionalQuantity,
          NutritionalUnit: nutrientComponentList[i].NutritionalUnit,
          PublishDiv: nutrientComponentList[i].PublishDiv,
          Hierarchy: nutrientComponentList[i].Hierarchy,
        };
        component.push(vo);
      }
      this.nutrientDetailList = component;
      // 栄養成分備考
      this.nutritionalNote = nutrientInfoList[0].NutritionalNote;
      // 誌面栄養成分情報がある場合
      this.enabledNutrientUnitAddFlg = false;		// 誌面栄養成分情報登録は非活性
      this.enabledNutrientUnitUpdateFlg = true;		// 誌面栄養成分情報メンテナンスは活性
      this.enabledNutrientUnitRemoveFlg = true;		// 誌面栄養成分情報削除は活性

    } else {
      this.nutrientUnitList = new Array<any>();
      this.nutrientDetailList = new Array<any>();
      this.nutritionalNote = null;
      // 誌面栄養成分情報がない場合
      this.enabledNutrientUnitAddFlg = true;		// 誌面栄養成分情報登録は活性
      this.enabledNutrientUnitUpdateFlg = false;		// 誌面栄養成分情報メンテナンスは非活性
      this.enabledNutrientUnitRemoveFlg = false;		// 誌面栄養成分情報削除は非活性
    }
    // 複数栄養成分情報
    if (serverData.NutrientInfoListMulti && serverData.NutrientInfoListMulti.List) {
      const multiNutrientInfoList: Array<any> = serverData.NutrientInfoListMulti.List;

      this.hiddenNutrientComponentList = new Array<any>();
      const multiUnitList: Array<any> = new Array<any>();
      for (let i = Number(0); i < multiNutrientInfoList.length; i++) {
        const multiNutrientInfo = multiNutrientInfoList[i];

        vo = {
          AnalysisUnit: multiNutrientInfo.AnalysisUnit,
        };
        multiUnitList.push(vo);

        const hiddenNutrientComponent: any = new Object();
        hiddenNutrientComponent.analysisSeqNo = multiNutrientInfo.AnalysisSeqNo;
        hiddenNutrientComponent.analysisUnit = multiNutrientInfo.AnalysisUnit;
        hiddenNutrientComponent.nutritionalNote = multiNutrientInfo.NutritionalNote;

        const multiNutrientComponentList: Array<any> = new Array<any>();
        for (let j = Number(0); j < multiNutrientInfo.NutrientComponentList.List.length; j++) {
          const multiNutrientComponent = multiNutrientInfo.NutrientComponentList.List[j];
          const multiComponentXml = {
            NutritionalName: multiNutrientComponent.NutritionalName,
            NutritionalQuantity: multiNutrientComponent.NutritionalQuantity === null
              ? '' : multiNutrientComponent.NutritionalQuantity,
            NutritionalUnit: multiNutrientComponent.NutritionalUnit,
            PublishDiv: multiNutrientComponent.PublishDiv,
            Hierarchy: multiNutrientComponent.Hierarchy,
          };

          multiNutrientComponentList.push(multiComponentXml);
        }
        hiddenNutrientComponent.nutrientInfoList = multiNutrientComponentList;

        // 栄養成分情報 hiddenには複数栄養情報のみセットする。
        this.hiddenNutrientComponentList.push(hiddenNutrientComponent);
        // 複数栄養成分あり
        if (!PlessViewUtilsSub.isEmptyArray(this.hiddenNutrientComponentList)) {
          this.hasMultiNutrientInfo = true;
        }
      }
      this.nutrientUnitListMulti = multiUnitList;

      this.changeNutrientInfoListMulti(0);
    } else {
      this.nutrientUnitListMulti = new Array<any>();
      this.nutrientDetailListMulti = new Array<any>();
      this.nutritionalNoteMulti = null;
      this.hiddenNutrientComponentList = new Array<any>();
      // 複数静養成分タブ分析単位コンテキストメニューの活性／非活性
      this.enabledNutrientUnitMultiAddFlg = true;
      this.enabledNutrientUnitMultiUpdateFlg = false;
      this.enabledNutrientUnitMultiRemoveFlg = false;
    }
  }

  /**
    * 複数栄養成分タブの栄養成分情報の入れ替え
    * @param idx インデックス
    */
  public changeNutrientInfoListMulti(idx: number): void {
    if (this.hiddenNutrientComponentList.length > idx && idx > -1) {
      this.nutrientDetailListMulti = this.hiddenNutrientComponentList[idx].nutrientInfoList;
      this.nutritionalNoteMulti = this.hiddenNutrientComponentList[idx].nutritionalNote;
      this.kymw1100Component.dtg_NutrientUnitListMulti.select(idx, -1);
    } else {
      this.nutrientDetailListMulti = new Array<any>();
      this.nutritionalNoteMulti = '';
    }
  }
  /**
    * 栄養成分メンテナンス画面からの戻りデータの反映
    * @param outputVO 商品栄養成分情報 出力用VO
    */
  public updateGoodsNutrientInfoByKYMW1107(outputVO: KYMW1107OutputModel): void {
    let vo: any;

    if (outputVO.analysisSeqNo === '0') {
      /* 誌面用栄養成分情報 */
      // 分析単位
      const unitList: Array<any> = new Array<any>();
      vo = {
        AnalysisUnit: outputVO.analysisUnit,
      };
      unitList.push(vo);
      this.nutrientUnitList = unitList;
      // 栄養成分
      const component: Array<any> = new Array<any>();
      for (let i = Number(0); i < outputVO.nutrientComponentList.length; i++) {
        vo = {
          NutritionalName: outputVO.nutrientComponentList[i].nutritionalName,
          NutritionalQuantity: outputVO.nutrientComponentList[i].nutritionalQuantity === null
            ? '' : outputVO.nutrientComponentList[i].nutritionalQuantity,
          NutritionalUnit: outputVO.nutrientComponentList[i].nutrientUnit,
          PublishDiv: outputVO.nutrientComponentList[i].publishDiv,
          Hierarchy: outputVO.nutrientComponentList[i].hierarchy,
        };
        component.push(vo);
      }
      this.nutrientDetailList = component;
      // 栄養成分備考
      this.nutritionalNote = outputVO.nutrientNote;
    } else {
      /* 複数栄養成分情報 */
      // 栄養成分情報 hiddenリストの要素生成
      const hiddenNutrientComponent: Object = this.createHiddenNutrientComponent(outputVO);
      // 栄養成分情報 hiddenリスト情報の入れ替え
      const idx: number = this.updateHiddenNutrientComponentList(hiddenNutrientComponent);
      // 分析単位
      const tempList = this.nutrientUnitListMulti.concat();
      if (!PlessViewUtilsSub.isEmptyArray(this.nutrientUnitListMulti) && idx < this.nutrientUnitListMulti.length) {
        // 入れ替える。
        tempList[idx].AnalysisUnit = outputVO.analysisUnit;
      } else {
        // 追加する。
        vo = {
          AnalysisUnit: outputVO.analysisUnit
        };
        tempList.push(vo);
      }
      this.nutrientUnitListMulti = tempList;
      // 栄養成分・栄養成分備考
      this.changeNutrientInfoListMulti(idx);
    }

  }

  /**
    * 栄養成分情報 hiddenリストの要素生成
    * @param outputVO 商品栄養成分情報メンテナンスからの戻り値VO
    * @return 生成要素
    */
  public createHiddenNutrientComponent(outputVO: KYMW1107OutputModel): Object {
    const hiddenNutrientComponent: any = new Object;
    hiddenNutrientComponent.analysisSeqNo = outputVO.analysisSeqNo;
    hiddenNutrientComponent.analysisUnit = outputVO.analysisUnit;
    hiddenNutrientComponent.nutritionalNote = outputVO.nutrientNote;

    const multiNutrientComponentList: Array<any> = new Array<any>();
    for (let j = Number(0); j < outputVO.nutrientComponentList.length; j++) {
      const multiNutrientComponent = outputVO.nutrientComponentList[j];
      const multiComponentXml = {
        NutritionalName: multiNutrientComponent.nutritionalName,
        NutritionalQuantity: multiNutrientComponent.nutritionalQuantity === null ? '' : multiNutrientComponent.nutritionalQuantity,
        NutritionalUnit: multiNutrientComponent.nutrientUnit,
        PublishDiv: multiNutrientComponent.publishDiv,
        Hierarchy: multiNutrientComponent.hierarchy,
      };

      multiNutrientComponentList.push(multiComponentXml);
    }
    hiddenNutrientComponent.nutrientInfoList = multiNutrientComponentList;

    return hiddenNutrientComponent;
  }

  /**
    * 栄養成分情報 hiddenリスト情報の入れ替え
    * @param outputVO 商品栄養成分情報メンテナンスからの戻り値VO
    * @return 入れ替えた要素のインデックス
    */
  public updateHiddenNutrientComponentList(hiddenNutrientComponent: any): number {
    // 栄養成分情報 hiddenリストの入れ替え対象を探す
    let idx: number;
    for (idx = 0; idx < this.hiddenNutrientComponentList.length; idx++) {
      if (this.hiddenNutrientComponentList[idx].analysisSeqNo
        === hiddenNutrientComponent.analysisSeqNo) {
        break;
      }
    }
    if (!PlessViewUtilsSub.isEmptyArray(this.hiddenNutrientComponentList) && idx < this.hiddenNutrientComponentList.length) {
      // 入れ替える。
      this.hiddenNutrientComponentList[idx] = hiddenNutrientComponent;
    } else {
      // 追加する。
      this.hiddenNutrientComponentList.push(hiddenNutrientComponent);
    }

    return idx;
  }

  /**
    * アイテム情報の環境関連タブ取得(検索後)
    * 温暖化防止
    * @param serverData ユーザーリストのサーバ取得データ
    */
  public updateGoodsEcologyList(serverData: any): void {
    if (serverData.GoodsEcologyList && serverData.GoodsEcologyList.List) {
      const goodsEcologyList = serverData.GoodsEcologyList.List;
      if (this.goodsEcologyListTmp != null) {
        // 環境区分が【00】があるかどうかを判断する
        const ecologyDiv: boolean = this.ecologyDivFlag(goodsEcologyList);

        let vo: any;
        const markList32: Array<any> = new Array<any>();
        for (let j = Number(0); j < this.goodsEcologyListTmp.length; j++) {
          // 環境区分が【00】の場合
          if (ecologyDiv) {
            if (PlessViewUtilsSub.trim(this.goodsEcologyListTmp[j].Div) === '00') {
              this.ecology = '1';
            } else {
              vo = {
                Check: false,
                EcologyDiv: this.goodsEcologyListTmp[j].Div,
                EcologyName: this.goodsEcologyListTmp[j].Name,
                Enabled: false,
              };

              markList32.push(vo);
            }
          } else if (ecologyDiv === false) {
            // 環境区分が【00】の以外の場合
            if (PlessViewUtilsSub.trim(this.goodsEcologyListTmp[j].Div) === '00') {
              this.ecology = '2';
            } else {
              const check: boolean = this.isExistEcologyDiv(goodsEcologyList, this.goodsEcologyListTmp[j].Div);
              vo = {
                Check: check,
                EcologyDiv: this.goodsEcologyListTmp[j].Div,
                EcologyName: this.goodsEcologyListTmp[j].Name,
                Enabled: true,
              };

              markList32.push(vo);
            }
          }
        }
        this.goodsEcologyList = markList32;
      } else {
        this.goodsEcologyList = null;
      }
    } else {
      // 環境区分が【Null】の場合
      const ecologyListTmp32: Array<any> = new Array<any>();
      if (this.goodsEcologyListTmp != null) {
        for (let i = Number(0); i < this.goodsEcologyListTmp.length; i++) {
          if (PlessViewUtilsSub.trim(this.goodsEcologyListTmp[i].Div) === '00') {
            this.ecology = '1';
          } else {
            const goodsTmpXml = {
              Check: false,
              EcologyDiv: this.goodsEcologyListTmp[i].Div,
              EcologyName: this.goodsEcologyListTmp[i].Name,
              Enabled: false,
            };

            ecologyListTmp32.push(goodsTmpXml);
          }
        }
        this.goodsEcologyList = ecologyListTmp32;
      } else {
        this.goodsEcologyList = null;
      }
    }
  }

  /**
    * 環境区分の情報があるかどうか判断する。
    */
  private ecologyDivFlag(goodsEcologyList: Array<any>): boolean {
    for (let i = Number(0); i < goodsEcologyList.length; i++) {
      if (goodsEcologyList[i].EcologyDiv === '00') {
        return true;
      }
    }
    return false;
  }

  /**
    * Pコードがある時にtrueを返す。
    */
  private isExistEcologyDiv(goodsEcologyList: Array<any>, EcologyDiv: string): boolean {
    for (let i = Number(0); i < goodsEcologyList.length; i++) {
      if (goodsEcologyList[i].EcologyDiv === PlessViewUtilsSub.trim(EcologyDiv)) {
        return true;
      }
    }
    return false;
  }

  /**
    * アイテム情報の環境関連タブ取得(初期表示)
    * 温暖化防止
    * @param serverData ユーザーリストのサーバ取得データ
    */
  public updateGWStopInfoList(serverData: any): void {
    if (serverData.GWStopInfoList && serverData.GWStopInfoList.GWStop) {
      this.goodsGWStopList = serverData.GWStopInfoList.GWStop;

      this.goodsGWStopListTmp = this.goodsGWStopList;

      const markList32: Array<any> = new Array<any>();
      for (let i = Number(0); i < this.goodsGWStopList.length; i++) {
        const vo = {
          Check: false,
          GWStopDiv: PlessViewUtilsSub.trim(this.goodsGWStopList[i].Div),
          GWStopName: PlessViewUtilsSub.trim(this.goodsGWStopList[i].Name),
        };

        markList32.push(vo);
      }

      this.goodsGWStopList = markList32;
    } else {
      this.goodsGWStopList = null;
      this.goodsGWStopListTmp = this.goodsGWStopList;
    }
    this.setInitialFocus();
  }

  /**
    * アイテム情報の環境関連タブ取得(検索後)
    * 温暖化防止
    * @param serverData ユーザーリストのサーバ取得データ
    */
  public updateGoodsGWStopList(serverData: any): void {
    if (serverData.GoodsGwstopList && serverData.GoodsGwstopList.List) {
      const goodsGWStopList = serverData.GoodsGwstopList.List;

      const markList32: Array<any> = new Array<any>();
      if (this.goodsGWStopListTmp != null) {
        for (let i = Number(0); i < this.goodsGWStopListTmp.length; i++) {
          const check: boolean = this.isExistGWStopDiv(goodsGWStopList, this.goodsGWStopListTmp[i].Div);

          const vo = {
            Check: check,
            GWStopDiv: PlessViewUtilsSub.trim(this.goodsGWStopListTmp[i].Div),
            GWStopName: PlessViewUtilsSub.trim(this.goodsGWStopListTmp[i].Name),
          };

          markList32.push(vo);
        }
        this.goodsGWStopList = markList32;
      } else {
        this.goodsGWStopList = null;
      }
    } else {
      const gwStopList32: Array<any> = new Array<any>();
      if (this.goodsGWStopListTmp != null) {
        for (let j = Number(0); j < this.goodsGWStopListTmp.length; j++) {
          const goodsGWStopXml = {
            Check: false,
            GWStopDiv: PlessViewUtilsSub.trim(this.goodsGWStopListTmp[j].Div),
            GWStopName: PlessViewUtilsSub.trim(this.goodsGWStopListTmp[j].Name),
          };

          gwStopList32.push(goodsGWStopXml);
        }
        this.goodsGWStopList = gwStopList32;
      } else {
        this.goodsGWStopList = null;
      }
    }
  }

  /**
    * Pコードがある時にtrueを返す。
    */
  private isExistGWStopDiv(goodsGWStopList: Array<any>, GWStopDiv: string): boolean {
    for (let i = Number(0); i < goodsGWStopList.length; i++) {
      if (goodsGWStopList[i].GoodsGwstopCode === PlessViewUtilsSub.trim(GWStopDiv)) {
        return true;
      }
    }
    return false;
  }
  /**
    * アイテム情報の環境関連タブ取得(初期表示)
    * 容器包装材
    * @param serverData ユーザーリストのサーバ取得データ
    */
  public updateContainPackingInfoList(serverData: any): void {
    if (serverData.ContainPackingList && serverData.ContainPackingList.Contain) {
      this.containPackingList = serverData.ContainPackingList.Contain;
      this.containPackingListTmp = this.containPackingList;

      const markList32: Array<any> = new Array<any>();
      for (let i = Number(0); i < this.containPackingList.length; i++) {
        const vo = {
          Check: false,
          ContainDiv: PlessViewUtilsSub.trim(this.containPackingList[i].Div),
          ContainDivName: this.containPackingList[i].DivName,
          ContainKind: PlessViewUtilsSub.trim(this.containPackingList[i].Kind),
          ContainKindName: this.containPackingList[i].KindName,
          PackMaterialWeight: '',
          Enabled: false,
        };

        markList32.push(vo);
      }

      this.containPackingList = markList32;
    } else {
      this.containPackingList = null;
      this.containPackingListTmp = this.containPackingList;
    }
    this.setInitialFocus();
  }
  /**
    * アイテム情報の環境関連タブ取得(チェックボックスイベント)
    * 容器包装材
    * @param serverData ユーザーリストのサーバ取得データ
    */
  public updateSelectedContainPackingInfo(data: any): void {
    // 該当行の場合
      if (!data.Check) {
        data.PackMaterialWeight = '';
    }
    this.kymw1100Component.dtg_ContainPackingList.refresh();
  }

  /**
    * アイテム情報の環境関連タブ取得(初期表示)
    * 容器包装材
    * @param serverData ユーザーリストのサーバ取得データ
    */
  public updateContainPackingList(serverData: any): void {
    if (serverData.ContainPackingList && serverData.ContainPackingList.List) {
      const goodsContainPackingList = serverData.ContainPackingList.List;

      const markList32: Array<any> = new Array<any>();
      if (this.containPackingListTmp != null) {
        for (let i = Number(0); i < this.containPackingListTmp.length; i++) {
          const check: boolean = this.isExistContainDiv(goodsContainPackingList, this.containPackingListTmp[i].Kind);
          const packMaterialWeight: string = this.isExistpackMaterialWeight(goodsContainPackingList, this.containPackingListTmp[i].Kind);

          const vo = {
            Check: check,
            ContainDiv: PlessViewUtilsSub.trim(this.containPackingListTmp[i].Div),
            ContainDivName: this.containPackingListTmp[i].DivName,
            ContainKind: PlessViewUtilsSub.trim(this.containPackingListTmp[i].Kind),
            ContainKindName: this.containPackingListTmp[i].KindName,
            PackMaterialWeight: packMaterialWeight,
            Enabled: check,
          };
          markList32.push(vo);
        }
        this.containPackingList = markList32;
      } else {
        this.containPackingList = null;
      }
    } else {
      const containList32: Array<any> = new Array<any>();
      if (this.containPackingListTmp != null) {
        for (let j = Number(0); j < this.containPackingListTmp.length; j++) {
          const goodsContainXml = {
            Check: false,
            ContainDiv: PlessViewUtilsSub.trim(this.containPackingListTmp[j].Div),
            ContainDivName: this.containPackingListTmp[j].DivName,
            ContainKind: PlessViewUtilsSub.trim(this.containPackingListTmp[j].Kind),
            ContainKindName: this.containPackingListTmp[j].KindName,
            PackMaterialWeight: '',
            Enabled: false,
          };

          containList32.push(goodsContainXml);
        }
        this.containPackingList = containList32;
      } else {
        this.containPackingList = null;
      }
    }
  }

  /**
    * Pコードがある時にtrueを返す。
    */
  private isExistContainDiv(goodsContainPackingList: Array<any>, ContainKind: string): boolean {
    for (let i = Number(0); i < goodsContainPackingList.length; i++) {
      if (PlessViewUtilsSub.trim(goodsContainPackingList[i].ContainKind) === PlessViewUtilsSub.trim(ContainKind)) {
        return true;
      }
    }
    return false;
  }

  private isExistpackMaterialWeight(goodsContainPackingList: Array<any>, ContainKind: string): string {
    for (let i = Number(0); i < goodsContainPackingList.length; i++) {
      if (PlessViewUtilsSub.trim(goodsContainPackingList[i].ContainKind) === PlessViewUtilsSub.trim(ContainKind)) {
        if (goodsContainPackingList[i].PackMaterialWeight != null) {
          return goodsContainPackingList[i].PackMaterialWeight;
        } else {
          return '';
        }
      }
    }
    return '';
  }

  /**
    * 発注先取引先コード設定する。
    * @param serverData ユーザーリストのサーバ取得データ
    */
  public setSupplierOrder(serverData: any): void {
    this.orderClientCode = serverData.Supplier;
    this.orderClientName = serverData.SupplierNameKanji;

    this.tradeStopDivOrder = PlessViewUtilsSub.trim(serverData.TradeStopDiv);
  }

  /**
    * 支払先取引先コード設定する。
    * @param serverData ユーザーリストのサーバ取得データ
    */
  public setSupplierPayee(serverData: any): void {
    this.payeeClientCode = serverData.Supplier;
    this.payeeClientName = serverData.SupplierNameKanji;

    this.tradeStopDivPayee = PlessViewUtilsSub.trim(serverData.TradeStopDiv);
  }

  /**
    * 登録が成功したときにPコード等を画面に設定する。
    * @param serverData ユーザーリストのサーバ取得データ
    */
  public registGoods(serverData: any): void {
    if (serverData.PCode != null) {
      this.pCode = serverData.PCode;
      // 排他制御を行う。
      this.kymw1100Component.eventUpdate();
    } else {
      this.pCode = this.pCode;
    }
    this.itemList = serverData.ItemList.List;

    for (let i = Number(0); i < this.itemList.length; i++) {
      if (PlessViewUtilsSub.trim(this.itemList[i].ItemCode) === serverData.ItemCode) {
        this.itemCode = String(i);
      }
    }

    // アイテムコード（コピー用）出力
    this.itemCode = this.itemList[this.itemCode].ItemCode;
    // 全生協一括設定クリア
    this.allCoop = false;
    this.updateDate = PlessViewUtilsSub.editDate(this.nullcheck(serverData.UpdateDate), '3');
    this.registDate = PlessViewUtilsSub.editDate(this.nullcheck(serverData.RegistDate), '3');


    if (this.admitStatus === '0') {
      this.kymw1100Component.rdb_AdmitStatus0.disabled = false;
      this.kymw1100Component.rdb_AdmitStatus1.disabled = false;
      this.kymw1100Component.rdb_AdmitStatus2.disabled = true;
      this.kymw1100Component.chk_PackMaterialShowFlg.nativeElement.disabled = true;
    } else if (this.admitStatus === '1') {
      this.kymw1100Component.rdb_AdmitStatus0.disabled = true;
      this.kymw1100Component.rdb_AdmitStatus1.disabled = false;
      this.kymw1100Component.rdb_AdmitStatus2.disabled = true;
      this.kymw1100Component.chk_PackMaterialShowFlg.nativeElement.disabled = false;
    } else if (this.admitStatus === '2') {
      this.kymw1100Component.rdb_AdmitStatus0.disabled = true;
      this.kymw1100Component.rdb_AdmitStatus1.disabled = true;
      this.kymw1100Component.rdb_AdmitStatus2.disabled = false;
      this.kymw1100Component.chk_PackMaterialShowFlg.nativeElement.disabled = true;
    }

    // 包材一括表示確認済がチェックされた場合本登録を活性化する。
    if (this.packMaterialShowFlg) {
      this.kymw1100Component.rdb_AdmitStatus2.disabled = false;
    }
  }

  /**
    * JANコードインストア採番
    * @param serverData ユーザーリストのサーバ取得データ
    */
  public setJANCode(serverData: any): void {
    this.janCode = serverData.JANCode;
  }

  /**
    * 消費税区分、消費税率取得
    * @param serverData ユーザーリストのサーバ取得データ
    */
  public setConsumeTax(serverData: any): void {

    const consumeTaxList = serverData;
    this.def_ConsumeTaxRate = consumeTaxList[0].ConsumeTaxRate;
    this.def_ConsumeTaxRate_2 = consumeTaxList[1].ConsumeTaxRate;

    // 消費税区分が「01：増税まえ」の場合
    if (this.isSelectedRateChangeMaster()) {
      if (PlessViewUtilsSub.isEmpty(this.consumeTaxDivList)
        && PlessViewUtilsSub.isEmpty(this.consumeTaxDivRate)) {
        this.consumeTaxDivList = PlessViewUtilsSub.trim(consumeTaxList[0].ConsumeTaxDiv);		// マスタ取得データ保存
        this.consumeTaxDivRate = consumeTaxList[0].ConsumeTaxRate;						// マスタ取得データ保存

        // 「01：増税まえ」の画面表示更新
        this.kymw1100Component.setConsumeDivAndTax(this.consumeTaxDivList, this.consumeTaxDivRate);
      }
      if (PlessViewUtilsSub.isEmpty(this.consumeTaxDivWk)
        && PlessViewUtilsSub.isEmpty(this.consumeTaxRateWk)) {
        this.consumeTaxDivWk = PlessViewUtilsSub.trim(consumeTaxList[1].ConsumeTaxDiv);		// Wk取得データ保存
        this.consumeTaxRateWk = consumeTaxList[1].ConsumeTaxRate;						// Wk取得データ保存
      }
    } else {
      // 消費税区分が「02：増税あと」の場合
      if (PlessViewUtilsSub.isEmpty(this.consumeTaxDivList)
        && PlessViewUtilsSub.isEmpty(this.consumeTaxDivRate)) {
        this.consumeTaxDivList = PlessViewUtilsSub.trim(consumeTaxList[0].ConsumeTaxDiv);		// マスタ取得データ保存
        this.consumeTaxDivRate = consumeTaxList[0].ConsumeTaxRate;						// マスタ取得データ保存
      }
      if (PlessViewUtilsSub.isEmpty(this.consumeTaxDivWk)
        && PlessViewUtilsSub.isEmpty(this.consumeTaxRateWk)) {
        this.consumeTaxDivWk = PlessViewUtilsSub.trim(consumeTaxList[1].ConsumeTaxDiv);		// Wk取得データ保存
        this.consumeTaxRateWk = consumeTaxList[1].ConsumeTaxRate;						// Wk取得データ保存

        // 「02：増税あと」の画面表示更新
        this.kymw1100Component.setConsumeDivAndTax(this.consumeTaxDivWk, this.consumeTaxRateWk);
      }
    }
    // 画面背景色を変更する
    this.setSelectedRateChange(this.selectedRateChange);

    // 利用生協の価格表更新
    this.setConsumeTaxPrice(this.getEditCoopInfoList());
  }


  /**
    * 商品仕様取込成功した時にログの画面を呼び出す
    * @param serverData ユーザーリストのサーバ取得データ
    */
  public setEbaseDataKYMW0D00(serverData: any): void {
    const inputVO: KYMW0D00InputModel = new KYMW0D00InputModel();
    // 画面ＩＤ
    inputVO.dispId = 'KYMW1100';
    // 正常件数
    inputVO.normalNum = serverData.NormalNum;
    // 注意件数
    inputVO.attentionNum = serverData.AttentionNum;
    // 異常件数
    inputVO.abnormalNum = serverData.AbnormalNum;
    // ＤＢ更新件数
    inputVO.updateNum = serverData.UpdateNum;
    // 処理件数
    inputVO.manageNum = serverData.ManageNum;

    this.kymw1100Component.eventKYMW0D00(inputVO);
  }

  private setInitialFocus(): void {
    if (this.initPhase) {
      this.kymw1100Component.btn_GoodsPCode.nativeElement.focus();
    }
  }


  /**
    * 文字情報・登録件数編集
    */
  private editTextInfoCount(count: string): string {
    let ret = '0件';

    // 入力パラメータのチェック
    if (!PlessViewUtilsSub.isEmpty(count)) {									// 指定ありの場合

      // 文字情報・登録件数を編集
      ret = count + '件';
    }

    // 文字情報・登録件数を返却
    return ret;
  }
  /**
    * 	消費税率区分Wk、消費税率Wkの初期化
    **/
  public initConsumeRateWk(): void {
    this.consumeTaxDivWk = CommonSetting.getVal('TAX_WK_DEF_CONSUME_DIV');	// 0：外税
    this.consumeTaxRateWk = CommonSetting.getVal('TAX_WK_DEF_CONSUME_RATE');	// 10%
  }

  /**
    * 	消費税率切り替えコンボボックスの初期化
    **/
  public initRateChange(): void {
    const initTaxDiv: string = <string>'01';

    this.setSelectedRateChange(initTaxDiv);

    // 表示更新
    this.kymw1100Component.setConsumeDivAndTax(initTaxDiv, this.getTargetConsumeTaxRate());
  }

  /**
    * 現在表示中の消費税区分を設定する
    */
  public setSelectedRateChange(selectedCodeValue: string): void {
    this.selectedRateChange = selectedCodeValue;

    const taxMstColorN: string = CommonSetting.getVal('KYMW1100_M_COLOR_N');		// 商品マスタ画面背景色(マスタ・通常税率)
    const taxMstColorR: string = CommonSetting.getVal('KYMW1100_M_COLOR_R');		// 商品マスタ画面背景色(マスタ・軽減税率)
    const taxWrkColorN: string = CommonSetting.getVal('KYMW1100_W_COLOR_N');		// 商品マスタ画面背景色(ワーク・通常税率)
    const taxWrkColorR: string = CommonSetting.getVal('KYMW1100_W_COLOR_R');		// 商品マスタ画面背景色(ワーク・軽減税率)
    const taxJudgeRate: string = CommonSetting.getVal('TAX_COLOR_JUDGE_RATE');		// 画面背景色切替判定消費税率

    if (selectedCodeValue === '01') {

      // 背景色切替判定消費税率と入力消費税率の比較
      if (taxJudgeRate === this.consumeTaxDivRateScreen) {						// 一致する場合(通常税率)

        // 商品マスタ画面背景色を設定
        this.color = taxMstColorN;										// 商品マスタ画面背景色(マスタ・通常税率)
      } else {														// 一致しない場合(軽減税率)

        // 商品マスタ画面背景色を設定
        this.color = taxMstColorR;										// 商品マスタ画面背景色(マスタ・軽減税率)
      }
    } else {															// 『ワーク画面』の表示中


      // 背景色切替判定消費税率と入力消費税率の比較
      if (taxJudgeRate === this.consumeTaxDivRateScreen) {						// 一致する場合(通常税率)

        // 商品マスタ画面背景色を設定
        this.color = taxWrkColorN;										// 商品マスタ画面背景色(ワーク・通常税率)
      } else {													// 一致しない場合(軽減税率)

        // 商品マスタ画面背景色を設定
        this.color = taxWrkColorR;										// 商品マスタ画面背景色(ワーク・軽減税率)
      }
    }

    // 利用生協タブの価格表カラムヘッダー名更新
    this.kymw1100Component.updateUseCoopInfoListColumnHeader();
  }

  /**
    * 現在表示中の消費税区分切り替えがマスターを参照する表示かチェックする
    */
  public isSelectedRateChangeMaster(): boolean {
    if (this.selectedRateChange === '02') {
      return false;
    }

    return true;
  }


  /**
    * 編集中の会員生協価格一覧(coopInfoList)を取得する
    */
  public getEditCoopInfoList(): Array<any> {
    if (!this.isSelectedRateChangeMaster()) {
      return this.coopInfoWkList;
    }

    return this.coopInfoList;
  }

  /**
    * 編集中の会員生協価格一覧の初期データ(coopInfoList)を取得する
    */
  public getEditCoopInfoListTmp(): Array<any> {
    if (!this.isSelectedRateChangeMaster()) {
      return this.coopInfoWkListTmp;
    }

    return this.coopInfoListTmp;
  }

  /**
    *	利用生協の5%表のデータ更新
  * 	5%表が表示対象の場合は表示も更新する
  */
  public setCoopInfoList(list: Array<any>): void {
    this.coopInfoList = list;
    if (this.isSelectedRateChangeMaster()) {
      this.coopInfoListScreen = list;
    }
  }

  /**
  *	利用生協の8%表のデータ更新
  * 	8%表が表示対象の場合は表示も更新する
  */
  public setCoopInfoWkList(list: Array<any>): void {
    this.coopInfoWkList = list;
    if (!this.isSelectedRateChangeMaster()) {
      this.coopInfoListScreen = list;
    }
  }

  /**
   * 商品候補一覧取得
   * @param serverData:サーバから取得された<CandidateGoods>タグ
   */
  public updateCandidateGoodsList(serverData: any): void {
    this.candidateGoodsList = serverData.CandidateGoodsList;

    //  ページ設定
    this.totalNum = Number(serverData.TotalNum);	        //  総件数
    this.startDispNum = Number(serverData.StartDispNum);	//  開始件数
    this.endDispNum = Number(serverData.EndDispNum);	    //  終了件数

    // ボタン制御
    // 一覧の総件数が１件以上の場合に出力ボタンを活性
    this.btnOutEnabled = (this.totalNum > 0) ? true : false;
    // ２ページ以上の場合に前へボタンを活性
    this.btnBackEnabled = (this.pageNo > 1) ? true : false;
    // 総件数より前の件数の場合に次へボタンを活性
    this.btnNextEnabled = (this.totalNum > this.endDispNum) ? true : false;

  }

  /**
   * 商品候補一覧出力
   * @param data:サーバから取得された<FileUrl>タグ
   */
  public updateFileUrl(data: any): void {
    this.fileUrl = data.FileUrl;
  }

  /**
    * コープ商品URL取込成功した時にログの画面を呼び出す
    * @param serverData ユーザーリストのサーバ取得データ
    */
  public setCoopGoodsUrlDataKYMW0D00(serverData: any): void {
    const inputVO: KYMW0D00InputModel = new KYMW0D00InputModel();
    // 画面ＩＤ
    inputVO.dispId = 'KYMW1100';
    // 正常件数
    inputVO.normalNum = serverData.NormalNum;
    // 注意件数
    inputVO.attentionNum = serverData.AttentionNum;
    // 異常件数
    inputVO.abnormalNum = serverData.AbnormalNum;
    // ＤＢ更新件数
    inputVO.updateNum = serverData.UpdateNum;
    // 処理件数
    inputVO.manageNum = serverData.ManageNum;

    this.kymw1100Component.eventKYMW0D00(inputVO);
  }

  /**
    * タグ情報取得
    * @param serverData ユーザーリストのサーバ取得データ
    */
  public setTagInfo(serverData: any): void {
    if (!PlessViewUtilsSub.isEmptyArray(serverData.TagList?.TagInfo)) {
      this.tagInfo = serverData.TagList.TagInfo;
    }
  }

  /**
    * 掲載媒体情報取得
    * @param serverData ユーザーリストのサーバ取得データ
    */
  public setPublishMediumInfo(serverData: any): void {
    this.mediumText = "";
    if (!PlessViewUtilsSub.isEmptyArray(serverData.MediumList?.MediumInfo)) {
      this.mediumList = serverData.MediumList.MediumInfo;
      for (let i = Number(0); i < this.mediumList.length; i++) {
        if (i != 0) {
          this.mediumText = this.mediumText.concat(",");
        }
        this.mediumText = this.mediumText.concat(this.mediumList[i].MediumName);
      }
    }
  }

  /**
    * コープ商品URL取得
    * @param serverData ユーザーリストのサーバ取得データ
    */
  public setCoopGoodsUrl(serverData: any): void {
    this.coopGoodsTitle = serverData.CoopGoodsTitle;
    this.coopGoodsUrl = serverData.CoopGoodsUrl;
  }
}
